import React, { useState, useEffect } from "react"
import axios from 'axios';
import authHeader from "helpers/authHeader";
import MetaTags from "react-meta-tags"
import Flatpickr from "react-flatpickr";
import Select from 'react-select'
import "flatpickr/dist/themes/material_blue.css";
import {
    Card,
    CardBody,
    Table,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    NavItem,
    NavLink,
    Row,
    Button,
    TabContent,
    TabPane,
    FormFeedback,

} from "reactstrap"

// Formik validation
import * as Yup from "yup";
import { ErrorMessage, useFormik } from "formik";
import { useHistory } from "react-router-dom";
import classnames from "classnames";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { getAPIUrl, updatePersonalDetailsUrl, form60Url, getOtherHolderDetails, updateAccountHoldersStatusUrl, additionalDetailsUrl, getCustomerAdditionalDetailsUrl } from "../../helpers/fakebackend_helper";
import ShowPhoto from "../../pages/JSBForms/ShowPhoto"

//redux
import { useSelector, useDispatch } from "react-redux";

//Get States
import { getState } from "../../store/actions";

//Get Occupation
import { getOccupation } from "../../store/actions";

//GetAll Poi
import { getPoi } from "../../store/actions";

//GetAll Education
import { getEducation } from "../../store/actions";

//GetAll OccupationDetails
import { getOccupationDetails } from "../../store/actions";

//GetAll AssetDetails
import { getAssetDetails } from "../../store/actions";

//GetAll OtherBankAccounts
import { getOtherBankAccounts } from "../../store/actions";

//GetAll Reason To Become a Customer
import { getReasonToBecomeCustomer } from "../../store/actions";

import TableRows from './TableRows';
import banner from "../../assets/images/banner/banner.jpg";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const OtherHolder = () => {

    var getBase64 = async (file) => {
        return await new Promise((resolve, reject) => {
            debugger;
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    //=============Define State====================
    const history = useHistory();
    const location = useLocation();

    const [branch, setBranch] = useState([]);
    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);
    // Account Type
    const [userAccountType, setUserAccountType] = useState(null)

    // Config for Annual Income
    const configForAnnualIncome = [
        {
            label: "Annual Income",
            value: ""
        },
        {
            label: "Upto 100000",
            value: 1
        },
        {
            label: "100001 to 500000",
            value: 2
        },
        {
            label: "500001 to 1000000",
            value: 3
        },
        {
            label: "1000001 to 2500000",
            value: 4
        },
        {
            label: "Above 2500000",
            value: 5
        },
    ];

    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    //GetAll OtherBankAccounts
    const { otherBankAccountsData } = useSelector(state => ({
        otherBankAccountsData: state.Registration.otherBankAccountsData,
    }));

    //GetAll Education
    const { educationData } = useSelector(state => ({
        educationData: state.Registration.educationData,
    }));

    //GetAll OccupationDetails
    const { occupationDetailsData } = useSelector(state => ({
        occupationDetailsData: state.Registration.occupationDetailsData,
    }));

    //GetAll AssetDetails
    const { assetDetailsData } = useSelector(state => ({
        assetDetailsData: state.Registration.assetDetailsData,
    }));

    const dispatch = useDispatch();
    const { stateData } = useSelector(state => ({
        stateData: state.Registration.stateData,
    }));

    //GetAll Occupation
    const { occupationData } = useSelector(state => ({
        occupationData: state.Registration.occupationData,
    }));

    //GetAll Poi
    const { poiData } = useSelector(state => ({
        poiData: state.Registration.poiData,
    }));

    //GetAll Reason To Become a Customer
    const { reasonToBecomeCustomer } = useSelector(state => ({
        reasonToBecomeCustomer: state.Registration.reasonToBecomeCustomer,
    }));

    function chkNumeric(e) {
        let input = e.target.value;

        if (input == "") {
            validation.handleChange(e);
        }
        else if (typeof input !== "undefined") {
            var pattern = new RegExp(/^[0-9\b]+$/);
            if (pattern.test(input)) {
                validation.handleChange(e);
            }
        }
    }

    const [rowsData, setRowsData] = useState([]);

    const addPoiRows = () => {
        debugger;
        if ($("#ddlPOI option:selected").val() == "") {
            ErrorMessage("Please select Proof of Identity!");
            $("#ddlPOI").focus();
            return;
        }
        else if ($("#ddlPOIPOA option:selected").val() == "") {
            ErrorMessage("Please select POI/POA!");
            $("#ddlPOIPOA").focus();
            return;
        }

        if (rowsData.some(person => person.SelectedProofofIdentity === $("#ddlPOI option:selected").text())) {
            ErrorMessage($("#ddlPOI option:selected").text() + " is already exists!");
            return;
        }

        const rowsInput = {
            poiid: '',
            SelectedProofofIdentity: $("#ddlPOI option:selected").text(),
            EnterNumber: '',
            POIPOA: $("#ddlPOIPOA option:selected").text(),
            Expiry: '',
            Upload: '',
            poifilepath: '',
            poifilepathurl: '',
            Delete: ''
        }
        setRowsData([...rowsData, rowsInput])
    }

    const deletePoiRows = (index) => {
        debugger;
        if (rowsData.length > 1) {
            const rows = [...rowsData];
            rows.splice(index, 1);
            setRowsData(rows);
        }
        else if (rowsData.length == 1) {
            ErrorMessage("Atleast one POI/POA document is Compulsory!");
        }
    }

    const handleChange = (index, evnt) => {
        debugger;
        const { name, value } = evnt.target;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = value;
        setRowsData(rowsInput);
    }

    const handleCheckChange = (index, evnt) => {
        debugger;
        const { name, checked } = evnt.target;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = checked;
        setRowsData(rowsInput);
    }

    const handleUploadChange = (index, evnt) => {
        debugger;
        const { name, value } = evnt.target;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = evnt.target.files[0];
        setRowsData(rowsInput);
    }

    //Upload files
    const [selectedPhotoFile, setSelectedPhotoFile] = React.useState("");
    const [selectedFile, setSelectedFile] = React.useState("");
    const [holdersData, setHoldersData] = useState([]);

    const [emailError, setEmailError] = useState('');
    const [panError, setPanError] = useState('');
    const [isPreloader, setPreloader] = useState(false);
    // State for tax residence & born in any other country
    const [resultOfFatca, setResultOfFatca] = useState({ taxNonIndia: false, bornNonIndia: false });

    function emailValidation(value) {
        debugger;
        const email = value.target.value;
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!email || regex.test(email)
            === false) {
            setEmailError('Enter valid Email!')
            return false;
        }
        else {
            setEmailError('')
            return true;
        }
    }

    function panValidation(pan) {
        const regex = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
        if (!pan || regex.test(pan) === false) {
            setPanError('Enter valid PAN number!')
        }
        else {
            setPanError('')
            return true;
        }
    }

    function passportValidation(passport) {
        debugger;
        var regex = new RegExp("^[A-PR-WY][1-9]\\d\\s?\\d{4}[1-9]$");
        if (!passport || regex.test(passport) === false) {
            return false;
        }
        else {
            return true;
        }
    }
    function licenseValidation(license) {
        debugger;
        var regex = new RegExp("^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$");
        if (!license || regex.test(license) === false) {
            return false;
        }
        else {
            return true;
        }
    }
    function voterIDValidation(voterId) {
        debugger;
        var regex = /^([A-Z]){3}([0-9]){7}?$/g;
        if (!voterId || regex.test(voterId) === false) {
            return false;
        }
        else {
            return true;
        }
    }

    //function aadharValidation(uid) {
    //    if (uid.length != 12) {
    //        return false;
    //    }

    //    var Verhoeff = {
    //        "d": [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    //        [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
    //        [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
    //        [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
    //        [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
    //        [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
    //        [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
    //        [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
    //        [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
    //        [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]],
    //        "p": [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    //        [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
    //        [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
    //        [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
    //        [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
    //        [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
    //        [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
    //        [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]],
    //        "j": [0, 4, 3, 2, 1, 5, 6, 7, 8, 9],
    //        "check": function (str) {
    //            var c = 0;
    //            str.replace(/\D+/g, "").split("").reverse().join("").replace(/[\d]/g, function (u, i) {
    //                c = Verhoeff.d[c][Verhoeff.p[i % 8][parseInt(u, 10)]];
    //            });
    //            return c;

    //        },
    //        "get": function (str) {

    //            var c = 0;
    //            str.replace(/\D+/g, "").split("").reverse().join("").replace(/[\d]/g, function (u, i) {
    //                c = Verhoeff.d[c][Verhoeff.p[(i + 1) % 8][parseInt(u, 10)]];
    //            });
    //            return Verhoeff.j[c];
    //        }
    //    };

    //    String.prototype.verhoeffCheck = (function () {
    //        var d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    //        [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
    //        [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
    //        [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
    //        [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
    //        [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
    //        [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
    //        [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
    //        [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
    //        [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]];
    //        var p = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    //        [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
    //        [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
    //        [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
    //        [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
    //        [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
    //        [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
    //        [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]];

    //        return function () {
    //            var c = 0;
    //            this.replace(/\D+/g, "").split("").reverse().join("").replace(/[\d]/g, function (u, i) {
    //                c = d[c][p[i % 8][parseInt(u, 10)]];
    //            });
    //            return (c === 0);
    //        };
    //    })();

    //    if (Verhoeff['check'](uid) === 0) {
    //        return true;
    //    } else {
    //        return false;
    //    }
    //}

    function aadharValidation(uid) {
        debugger;
        var regex = new RegExp("^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$");
        if (!uid || regex.test(uid) === false) {
            return false;
        }
        else {
            if (uid.length != 12) {
                return false;
            }

            var Verhoeff = {
                "d": [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
                [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
                [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
                [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
                [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
                [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
                [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
                [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
                [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]],
                "p": [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
                [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
                [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
                [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
                [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
                [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
                [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]],
                "j": [0, 4, 3, 2, 1, 5, 6, 7, 8, 9],
                "check": function (str) {
                    var c = 0;
                    str.replace(/\D+/g, "").split("").reverse().join("").replace(/[\d]/g, function (u, i) {
                        c = Verhoeff.d[c][Verhoeff.p[i % 8][parseInt(u, 10)]];
                    });
                    return c;

                },
                "get": function (str) {

                    var c = 0;
                    str.replace(/\D+/g, "").split("").reverse().join("").replace(/[\d]/g, function (u, i) {
                        c = Verhoeff.d[c][Verhoeff.p[(i + 1) % 8][parseInt(u, 10)]];
                    });
                    return Verhoeff.j[c];
                }
            };

            String.prototype.verhoeffCheck = (function () {
                var d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
                [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
                [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
                [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
                [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
                [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
                [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
                [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
                [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]];
                var p = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
                [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
                [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
                [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
                [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
                [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
                [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]];

                return function () {
                    var c = 0;
                    this.replace(/\D+/g, "").split("").reverse().join("").replace(/[\d]/g, function (u, i) {
                        c = d[c][p[i % 8][parseInt(u, 10)]];
                    });
                    return (c === 0);
                };
            })();

            if (Verhoeff['check'](uid) === 0) {
                return true;
            } else {
                return false;
            }
        }
    }

    function getCustomerAge() {
        // var dob = new Date(validation.values.dob);
        // var today = new Date();
        // var age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));
        // return age;

        const dob = new Date(validation.values.dob);
        const today = new Date();

        let age = today.getFullYear() - dob.getFullYear();

        const hasBirthdayPassedThisYear =
            today.getMonth() > dob.getMonth() ||
            (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate());

        if (!hasBirthdayPassedThisYear) {
            age--; // Birthday hasn't occurred yet this year
        }

        return age;
    }

    // Allowed Extension
    const allowedExtensions = ['image/png', 'image/jpeg', 'image/jpg'];

    function handlePhotoUpload(event) {
        const fileData = event?.target.files[0];
        if (!allowedExtensions.includes(fileData?.type)) {
            ErrorMessage("Kindly upload document in JPG,JPEG,PNG format only")
            validation.setFieldValue("photofile", "")
        } else {
            validation.handleChange(event)
            setSelectedPhotoFile(event.target.files[0]);
        }
    }

    function handleUpload(event) {
        const fileData = event?.target.files[0];
        if (!allowedExtensions.includes(fileData?.type)) {
            ErrorMessage("Kindly upload document in JPG,JPEG,PNG format only")
            validation.setFieldValue("panfile", "")
        } else {
            validation.handleChange(event)
            setSelectedFile(event.target.files[0]);
        }
    }

    var authCustomerObject = JSON.parse(localStorage.getItem('authCustomer'));

    const registrationHoldersPOIList = [];

    var registrationHoldersPOI = {
        POI: '',
        POINo: '',
        IsPOI: '',
        IsPOA: '',
        ExpiryDate: '',
        Base64POI: ''
    }

    var objRegistrationHolders = {
        Title: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        DOB: '',
        Gender: '',
        Nationality: '',
        Occupation: '',
        Mobile: '',
        Email: '',
        MartialStatus: '',
        LocalAddress1: '',
        LocalAddress2: '',
        LocalAddress3: '',
        LocalCity: '',
        LocalPin: '',
        LocalState: '',
        PermanentAddress1: '',
        PermanentAddress2: '',
        PermanentAddress3: '',
        PermanentCity: '',
        PermanentPin: '',
        PermanentState: '',
        PAN: '',
        Base64PAN: '',
        registrationHoldersPOI: registrationHoldersPOIList
    }

    const personalDetails = {
        RegistrationId: localStorage.getItem("registrationId"),
        objRegistrationHolders: objRegistrationHolders
    }

    const form60 = {
        RegistrationId: '',
        DeclarantDocuments: '',
        DeclarantTransactionParticulars: '',
        DeclarantAmountofTransaction: '',
        DeclarantAssessedTax: '',
        DetailsOfIncomeTax: '',
        ReasonForNoPan: ''
    }

    const additionalDetails = {
        RegistrationId: '',
        FundsExpectedOrigin: '',
        FundsUtilisationExpected: '',
        OtherBankAccounts: '',
        Turnover: '',
        AverageIncome: '',
        AverageBalance: '',
        Education: '',
        Religion: '',
        OccupationDetails: '',
        LineOfBusiness: '',
        BusinessName: '',
        BusinessStartDate: '',
        BusinessAddress1: '',
        BusinessAddress2: '',
        BusinessAddress3: '',
        BusinessTelNo: '',
        BusinessMobileNo: '',
        BusinessAnnualIncome: '',
        BusinessIncomeSource: '',
        BusinessWealthSource: '',
        BusinessEstimatedValue: '',
        BusinessAssetDetails: '',
        BornNonIndia: '',
        TaxResidenceNonIndia: '',
        BusinessVehicleType: '',
        BusinessCarPurchaseYear: '',
        BusinessCarMaker: '',
        InterestedIn: '',
        CustomerReasonId: ''
    }

    const registrationHoldersId = localStorage.getItem('registrationHoldersId');

    function GetOtherHolderDetails() {
        debugger;
        const createAccountHolderModel = {
            RegistrationId: localStorage.getItem('registrationId'),
            RegistrationHolderId: registrationHoldersId
        };

        setPreloader(true);

        axios.post(getOtherHolderDetails(), createAccountHolderModel, { headers: authHeader() }).then((response) => {
            if (response.data.length != 0 && response.data[0].declarantAssessedTax != null) {
                if (response.data[0].declarantAssessedTax == true) {
                    $('#rbaccessedtaxyes').prop('checked', true);
                    $('#rbaccessedtaxno').prop('checked', false);
                }
                else if (response.data[0].declarantAssessedTax == false) {
                    $('#rbaccessedtaxyes').prop('checked', false);
                    $('#rbaccessedtaxno').prop('checked', true);
                }
            }

            if (response.data.length != 0 && response.data[0].isPAN != null) {
                if (response.data[0].isPAN == false) {
                    $('#chkPAN').prop('checked', true);
                    $("#txtPancard").attr('disabled', 'disabled');
                    $("#Upload").attr('disabled', 'disabled');
                    $("#txtPancard").val('');
                }
                else if (response.data[0].isPAN == true) {
                    $('#chkPAN').prop('checked', false);
                    $("#txtPancard").removeAttr('disabled');
                    $("#Upload").removeAttr('disabled');
                }
            }

            if (response.data.length == 0) {
                setHoldersData(response.data);
                BindPOIPOA(response.data);
                setPreloader(false);
                return;
            }
            else if (response.data.length > 0) {
                if (response.data[0].photoFilePath != "") {
                    $("#lnkPhotoDownload").css("visibility", "visible");
                    $("#lnkPhotoDownload").prop("href", getAPIUrl() + "/Photo/" + response.data[0].photoFilePath);
                }
                if (response.data[0].panFilePath != "") {
                    $("#lnkPANDownload").css("visibility", "visible");
                    $("#lnkPANDownload").prop("href", getAPIUrl() + "/POIFiles/" + response.data[0].panFilePath);
                }

                BindAdditionalDetails(response.data[0]);
                setHoldersData(response.data[0]);
                BindPOIPOA(response.data);
                setPreloader(false);
            }

            setPreloader(false);
        }, (error) => {
            ErrorMessage(error.response);
            setPreloader(false);
        });
    }

    useEffect(() => {
        debugger;
        if (isPreloader === true) {
            document.getElementById("preloader").style.display = "block";
            document.getElementById("status").style.display = "block";
        } else {
            document.getElementById("preloader").style.display = "none";
            document.getElementById("status").style.display = "none";
        }
    }, [isPreloader]);

    useEffect(() => {
        dispatch(getReasonToBecomeCustomer());
        dispatch(getState());
        dispatch(getOccupation());
        dispatch(getPoi());
        dispatch(getEducation());
        dispatch(getOccupationDetails());
        dispatch(getAssetDetails());
        dispatch(getOtherBankAccounts());
        GetOtherHolderDetails();
    }, [dispatch]);

    function BindAdditionalDetails(additionalDetails) {
        debugger;
        if (additionalDetails != null) {
            additionalDetails.fundsExpectedOrigin == null ? $('#ddlfundsforcredit option:selected').val(1) : additionalDetails.fundsExpectedOrigin == '' ? $('#ddlfundsforcredit option:selected').val(1) : $('#ddlfundsforcredit option:selected').text(additionalDetails.fundsExpectedOrigin);
            additionalDetails.fundsUtilisationExpected == null ? $('#ddlfundsbydebit option:selected').val(1) : additionalDetails.fundsUtilisationExpected == '' ? $('#ddlfundsbydebit option:selected').val(1) : $('#ddlfundsbydebit option:selected').text(additionalDetails.fundsUtilisationExpected);
            additionalDetails.otherBankAccounts == null ? $('#ddlotherbanksaccounts option:selected').val(1) : additionalDetails.otherBankAccounts == '' ? $('#ddlotherbanksaccounts option:selected').val(1) : $('#ddlotherbanksaccounts option:selected').text(additionalDetails.otherBankAccounts);
            $('#txtturnover').val(additionalDetails.turnover);
            $('#txtaverageincome').val(additionalDetails.averageIncome);
            $('#txtexpectedincome').val(additionalDetails.averageBalance);
            additionalDetails.education == null ? $('#ddleducation option:selected').val(1) : additionalDetails.education == '' ? $('#ddleducation option:selected').val(1) : $('#ddleducation option:selected').text(additionalDetails.education);
            // additionalDetails.religion == null ? $('#ddlreligion option:selected').val(1) : additionalDetails.religion == '' ? $('#ddlreligion option:selected').val(1) : $('#ddlreligion option:selected').text(additionalDetails.religion);
            // additionalDetails.occupationDetails == null ? $('#ddloccupationdetails option:selected').val(1) : additionalDetails.occupationDetails == '' ? $('#ddloccupationdetails option:selected').val(1) : $('#ddloccupationdetails option:selected').text(additionalDetails.occupationDetails);
            $('#txtlineofnusiness').val(additionalDetails.lineOfBusiness);
            // $('#txtbusinessname').val(additionalDetails.businessName);
            $('#txtstartbusinessdate').val(additionalDetails.businessStartDate);
            $('#txtbussinessaddress1').val(additionalDetails.businessAddress1);
            $('#txtbussinessaddress2').val(additionalDetails.businessAddress2);
            $('#txtbussinessaddress3').val(additionalDetails.businessAddress3);
            $('#txtofficecontact').val(additionalDetails.businessTelNo);
            $('#txtofficemobileno').val(additionalDetails.businessMobileNo);
            // additionalDetails.businessAnnualIncome == null ? $('#ddlannualincome option:selected').val(1) : additionalDetails.businessAnnualIncome == '' ? $('#ddlannualincome option:selected').val(1) : $('#ddlannualincome option:selected').text(additionalDetails.businessAnnualIncome);
            // $('#txtsourceofincome').val(additionalDetails.businessIncomeSource);
            $('#txtsourceofwealth').val(additionalDetails.businessWealthSource);
            additionalDetails.businessEstimatedValue == null ? $('#ddlestimatedvalue option:selected').val(1) : additionalDetails.businessEstimatedValue == '' ? $('#ddlestimatedvalue option:selected').val(1) : $('#ddlestimatedvalue option:selected').text(additionalDetails.businessEstimatedValue);
            // additionalDetails.caste == null ? $('#caste option:selected').val(1) : additionalDetails.caste == '' ? $('#caste option:selected').val(1) : $('#caste option:selected').text(additionalDetails.caste);

            if (additionalDetails.businessAssetDetails != null) {
                if (additionalDetails.businessAssetDetails.length > 0) {
                    if (additionalDetails.businessAssetDetails.includes('Commercial Property')) {
                        $('#chkcommercialproperty').prop('checked', true);
                    }
                    else {
                        $('#chkcommercialproperty').prop('checked', false);
                    }

                    if (additionalDetails.businessAssetDetails.includes('House')) {
                        $('#chkhouse').prop('checked', true);
                    }
                    else {
                        $('#chkhouse').prop('checked', false);
                    }

                    if (additionalDetails.businessAssetDetails.includes('Plot')) {
                        $('#chkplot').prop('checked', true);
                    }
                    else {
                        $('#chkplot').prop('checked', false);
                    }

                    if (additionalDetails.businessAssetDetails.includes('Others')) {
                        $('#chkothers').prop('checked', true);
                    }
                    else {
                        $('#chkothers').prop('checked', false);
                    }
                }
            }

            if (additionalDetails.taxResidenceNonIndia != null) {
                if (additionalDetails.taxResidenceNonIndia == true) {
                    $('#rbtaxresidenceyes').prop('checked', true);
                    $('#rbtaxresidenceno').prop('checked', false);
                }
                else if (additionalDetails.taxResidenceNonIndia == false) {
                    $('#rbtaxresidenceyes').prop('checked', false);
                    $('#rbtaxresidenceno').prop('checked', true);
                }
            }

            if (additionalDetails.bornNonIndia != null) {
                if (additionalDetails.bornNonIndia == true) {
                    $('#rbbornyes').prop('checked', true);
                    $('#rbbornno').prop('checked', false);
                }
                else if (additionalDetails.bornNonIndia == false) {
                    $('#rbbornyes').prop('checked', false);
                    $('#rbbornno').prop('checked', true);
                }
            }

            if (additionalDetails.businessVehicleTwoWheeler != null) {
                if (additionalDetails.businessVehicleTwoWheeler.length > 0) {
                    if (additionalDetails.businessVehicleTwoWheeler.includes('Two Wheeler')) {
                        $('#chktwowheeler').prop('checked', true);
                        $('#twowheeleryear').val(additionalDetails.businessTwoWheelerPurchaseYear);
                    }
                    else {
                        $('#chktwowheeler').prop('checked', false);
                    }
                }
            }

            if (additionalDetails.businessVehicleCar != null) {
                if (additionalDetails.businessVehicleCar.length > 0) {
                    if (additionalDetails.businessVehicleCar.includes('Car')) {
                        $('#chkcar').prop('checked', true);
                        $('#txtcaryear').val(additionalDetails.businessCarPurchaseYear);
                    }
                    else {
                        $('#chkcar').prop('checked', false);
                    }
                }
            }

            if (additionalDetails.businessVehicleOther != null) {
                if (additionalDetails.businessVehicleOther.length > 0) {
                    if (additionalDetails.businessVehicleOther.includes('Other')) {
                        $('#chkother').prop('checked', true);
                        $('#txtotheryear').val(additionalDetails.businessOtherPurchaseYear);
                    }
                    else {
                        $('#chkother').prop('checked', false);
                    }
                }
            }

            if (additionalDetails.interestedIn != null) {
                if (additionalDetails.interestedIn.length > 0) {
                    if (additionalDetails.interestedIn.includes('Mutual Funds')) {
                        $('#chkmutualfunds').prop('checked', true);
                    }
                    else {
                        $('#chkmutualfunds').prop('checked', false);
                    }

                    if (additionalDetails.interestedIn.includes('Health Insurance')) {
                        $('#chkhealthinsurance').prop('checked', true);
                    }
                    else {
                        $('#chkhealthinsurance').prop('checked', false);
                    }

                    if (additionalDetails.interestedIn.includes('General Insurance')) {
                        $('#chkgeneralinsurance').prop('checked', true);
                    }
                    else {
                        $('#chkgeneralinsurance').prop('checked', false);
                    }

                    if (additionalDetails.interestedIn.includes('Demat')) {
                        $('#chkdemat').prop('checked', true);
                    }
                    else {
                        $('#chkdemat').prop('checked', false);
                    }

                    if (additionalDetails.interestedIn.includes('Pradhan Mantri Suraksha Bima Yojana (PMSBY)')) {
                        $('#chkpmsby').prop('checked', true);
                    }
                    else {
                        $('#chkpmsby').prop('checked', false);
                    }

                    if (additionalDetails.interestedIn.includes('Pradhan Mantri Jeevan Jyoti Bima Yojana (PMJJBY)')) {
                        $('#chkpmjjby').prop('checked', true);
                    }
                    else {
                        $('#chkpmjjby').prop('checked', false);
                    }
                }
            }

            $('#txtcarmaker').val(additionalDetails.businessCarMaker);
        }
    }

    function disablePAN() {
        if ($("#chkPAN").prop('checked') == true) {
            $("#txtPancard").attr('disabled', 'disabled');
            $("#Upload").attr('disabled', 'disabled');
            $("#txtPancard").val('');
        }
        else {
            $("#txtPancard").removeAttr('disabled');
            $("#Upload").removeAttr('disabled');
        }
    }

    function otherHolderSave(personalDetails, tabId) {
        if (selectedPhotoFile != '' && selectedFile != '') {

            setPreloader(true);
            getBase64(selectedPhotoFile).then(
                photodata => {
                    objRegistrationHolders.Base64Photo = photodata;

                    getBase64(selectedFile).then(
                        poidata => {
                            objRegistrationHolders.Base64PAN = poidata

                            axios.post(updatePersonalDetailsUrl(), personalDetails, { headers: authHeader() })
                                .then(res => {
                                    if (res.data.responseCode == "OK") {
                                        if ($("#chkPAN").prop('checked') == true) {
                                            toggleTabVertical(tabId + 1);
                                            setPreloader(false);
                                        }
                                        else if ($("#chkPAN").prop('checked') == false) {
                                            toggleTabVertical(tabId + 2);
                                            setPreloader(false);
                                        }
                                    }
                                    else {
                                        ErrorMessage(res.data.responseMessage);
                                        setPreloader(false);
                                    }
                                })
                        }
                    );
                }
            );
        }
        else if (selectedPhotoFile != '' && selectedFile == '') {

            setPreloader(true);
            objRegistrationHolders.Base64PAN = '';

            getBase64(selectedPhotoFile).then(
                photodata => {
                    objRegistrationHolders.Base64Photo = photodata;

                    axios.post(updatePersonalDetailsUrl(), personalDetails, { headers: authHeader() })
                        .then(res => {
                            if (res.data.responseCode == "OK") {
                                if ($("#chkPAN").prop('checked') == true) {
                                    toggleTabVertical(tabId + 1);
                                    setPreloader(false);
                                }
                                else if ($("#chkPAN").prop('checked') == false) {
                                    toggleTabVertical(tabId + 2);
                                    setPreloader(false);
                                }
                            }
                            else {
                                ErrorMessage(res.data.responseMessage);
                                setPreloader(false);
                            }
                        })
                }
            );
        }
        else if (selectedPhotoFile == '' && selectedFile != '') {

            setPreloader(true);
            objRegistrationHolders.Base64Photo = '';

            getBase64(selectedFile).then(
                poidata => {
                    objRegistrationHolders.Base64PAN = poidata;

                    axios.post(updatePersonalDetailsUrl(), personalDetails, { headers: authHeader() })
                        .then(res => {
                            if (res.data.responseCode == "OK") {
                                if ($("#chkPAN").prop('checked') == true) {
                                    toggleTabVertical(tabId + 1);
                                    setPreloader(false);
                                }
                                else if ($("#chkPAN").prop('checked') == false) {
                                    toggleTabVertical(tabId + 2);
                                    setPreloader(false);
                                }
                            }
                            else {
                                ErrorMessage(res.data.responseMessage);
                                setPreloader(false);
                            }
                        })
                }
            );
        }
        else if (selectedPhotoFile == '' && selectedFile == '') {

            setPreloader(true);
            objRegistrationHolders.Base64Photo = '';
            objRegistrationHolders.Base64PAN = '';

            axios.post(updatePersonalDetailsUrl(), personalDetails, { headers: authHeader() })
                .then(res => {
                    if (res.data.responseCode == "OK") {
                        if ($("#chkPAN").prop('checked') == true) {
                            toggleTabVertical(tabId + 1);
                            setPreloader(false);
                        }
                        else if ($("#chkPAN").prop('checked') == false) {
                            toggleTabVertical(tabId + 2);
                            setPreloader(false);
                        }
                    }
                    else {
                        ErrorMessage(res.data.responseMessage);
                        setPreloader(false);
                    }
                })
        }
    }

    function CreateAccount(tabId) {
        debugger;

        var today = new Date();

        if (tabId == 1) {

            //toggleTabVertical(tabId + 1);
            //return;

            if ($('#txtPhoneno').val().length > 0) {
                if ($('#txtPhoneno').val().length != 10) {
                    $('#txtPhoneno').focus();
                    ErrorMessage("Please enter 10 digit Mobile number!");
                    return;
                }
            }

            if (($('#txtPancard').val().trim() == "") && ($("#chkPAN").prop('checked') == false)) {
                $('#txtPancard').focus();
                ErrorMessage("Please enter PAN No. or check Form60!");
                return;
            }

            if ($("#chkPAN").prop('checked') == false) {
                $('#navForm60').css('background-color', 'lightgrey');
            }
            else {
                $('#navForm60').css('background-color', '');
            }

            debugger;
            if ($("#chkPAN").prop('checked') == false) {
                if (!panValidation($('#txtPancard').val().trim())) {
                    ErrorMessage('Please enter valid PAN Number!');
                    $('#txtPancard').focus();
                    return;
                }
            }

            var IsValid = false;

            if (rowsData.length == 0) {
                ErrorMessage("Please add atleast one POI/POA document!");
                return IsValid = false;
            }
            else {
                rowsData.map(poiCustomerData => {
                    debugger;
                    if (poiCustomerData.EnterNumber.trim().length == 0) {
                        ErrorMessage("Please enter Document Number for " + poiCustomerData.SelectedProofofIdentity + "!");
                        return IsValid = false;
                    }
                    else if (userAccountType !== 5 && poiCustomerData.Upload.length == 0 && poiCustomerData.poifilepath.length == 0) {
                        ErrorMessage("Please uplaod document for " + poiCustomerData.SelectedProofofIdentity + "!");
                        return IsValid = false;
                    }
                    else {
                        return IsValid = true;
                    }
                })
            }

            rowsData.map(poiCustomerData => {
                if (poiCustomerData.EnterNumber.trim().length > 0) {
                    if (poiCustomerData.SelectedProofofIdentity == "Passport" && (!passportValidation(poiCustomerData.EnterNumber))) {
                        ErrorMessage('Please enter valid Passport Number!');
                        return IsValid = false;
                    }
                    else if (poiCustomerData.SelectedProofofIdentity == "UID-Aadhaar No." && (!aadharValidation(poiCustomerData.EnterNumber))) {
                        ErrorMessage('Please enter valid Aadhaar Number!');
                        return IsValid = false;
                    }
                    else if (poiCustomerData.SelectedProofofIdentity == "License" && (!licenseValidation(poiCustomerData.EnterNumber))) {
                        ErrorMessage('Please enter valid License Number!');
                        return IsValid = false;
                    }
                    //else if (poiCustomerData.SelectedProofofIdentity == "Voter ID" && (!voterIDValidation(poiCustomerData.EnterNumber))) {
                    //    ErrorMessage('Please enter valid Voter ID Number!');
                    //    return IsValid = false;
                    //}
                }
            })

            if (rowsData.find(p => p.POIPOA == "POA & POI") == undefined) {
                if (rowsData.find(p => p.POIPOA == "POI") == undefined) {
                    ErrorMessage("Please add POI document!");
                    return IsValid = false;
                }
                else if (rowsData.find(p => p.POIPOA == "POA") == undefined) {
                    ErrorMessage("Please add POA document!");
                    return IsValid = false;
                }
            }

            var age = getCustomerAge();
            var isPAN = "true";
            if ($("#chkPAN").prop('checked') == true) {
                isPAN = "false";
            }

            if (IsValid) {

                objRegistrationHolders = {};

                objRegistrationHolders.Id = registrationHoldersId;
                objRegistrationHolders.Title = $('#ddlpersonalchoose').val();
                objRegistrationHolders.FirstName = $('#txtFirstName').val().trim();
                objRegistrationHolders.MiddleName = $('#txtMiddleName').val().trim();
                objRegistrationHolders.LastName = $('#txtLastName').val().trim();
                objRegistrationHolders.DOB = $('#txtdob').val();
                objRegistrationHolders.Gender = $('#ddlgender').val();
                objRegistrationHolders.Nationality = $('#ddlnationality').val();
                objRegistrationHolders.Occupation = $('#ddloccupation').val().trim();
                objRegistrationHolders.Mobile = $('#txtPhoneno').val().trim();
                objRegistrationHolders.Email = $('#txtEmailID').val().trim();
                objRegistrationHolders.MartialStatus = $('#ddlmaratialstatus').val();
                objRegistrationHolders.LocalAddress1 = $('#txtCommunicationAddress1').val().trim();
                objRegistrationHolders.LocalAddress2 = $('#txtCommunicationAddress2').val().trim();
                objRegistrationHolders.LocalAddress3 = $('#txtCommunicationAddress3').val().trim();
                objRegistrationHolders.LocalCity = $('#txtCommunicationCity').val().trim();
                objRegistrationHolders.LocalPin = $('#txtCommunicationPincode').val().trim();
                objRegistrationHolders.LocalState = $('#ddlCommunicationState').val();
                objRegistrationHolders.PermanentAddress1 = $('#txtPermanentAddress1').val().trim();
                objRegistrationHolders.PermanentAddress2 = $('#txtPermanentAddress2').val().trim();
                objRegistrationHolders.PermanentAddress3 = $('#txtPermanentAddress3').val().trim();
                objRegistrationHolders.PermanentCity = $('#txtPermanentCity').val().trim();
                objRegistrationHolders.PermanentPin = $('#txtPermanentPincode').val().trim();
                objRegistrationHolders.PermanentState = $('#ddlPermanentState').val();
                objRegistrationHolders.PAN = $('#txtPancard').val();
                objRegistrationHolders.IsMinor = age < 18 ? "true" : "false";
                objRegistrationHolders.isPAN = isPAN;
                objRegistrationHolders.CustomerId = $('#txtCustomerID').val().trim();
                objRegistrationHolders.CKYCNo = $('#txtCKYCNumber').val().trim();
                objRegistrationHolders.mobileNoBelongsTo = validation.values.mobilenobelongsTo;

                rowsData.map(poiCustomerData => {
                    if (poiCustomerData.Upload != "") {
                        getBase64(poiCustomerData.Upload).then(data => {
                            registrationHoldersPOI = {};
                            registrationHoldersPOI.POIId = poiCustomerData.poiid;
                            registrationHoldersPOI.Base64POI = data;
                            registrationHoldersPOI.POI = poiCustomerData.SelectedProofofIdentity;
                            registrationHoldersPOI.POINo = poiCustomerData.EnterNumber;
                            registrationHoldersPOI.POIPOA = poiCustomerData.POIPOA;
                            registrationHoldersPOI.ExpiryDate = poiCustomerData.Expiry;
                            registrationHoldersPOIList.push(registrationHoldersPOI);

                            if (registrationHoldersPOIList.length == rowsData.length) {
                                objRegistrationHolders.registrationHoldersPOI = registrationHoldersPOIList;
                                personalDetails.objRegistrationHolders = objRegistrationHolders;

                                otherHolderSave(personalDetails, tabId);
                            }
                        })
                    }
                    else {
                        registrationHoldersPOI = {};
                        registrationHoldersPOI.POIId = poiCustomerData.poiid;
                        registrationHoldersPOI.Base64POI = "";
                        registrationHoldersPOI.POI = poiCustomerData.SelectedProofofIdentity;
                        registrationHoldersPOI.POINo = poiCustomerData.EnterNumber;
                        registrationHoldersPOI.POIPOA = poiCustomerData.POIPOA;
                        registrationHoldersPOI.ExpiryDate = poiCustomerData.Expiry;
                        registrationHoldersPOIList.push(registrationHoldersPOI);

                        if (registrationHoldersPOIList.length == rowsData.length) {
                            objRegistrationHolders.registrationHoldersPOI = registrationHoldersPOIList;
                            personalDetails.objRegistrationHolders = objRegistrationHolders;

                            otherHolderSave(personalDetails, tabId);
                        }
                    }
                })
            }
        }
        else if (tabId == 2) {

            //toggleTabVertical(tabId + 1);
            //return;

            var DeclarantAssessedTax = false;

            if ($("#rbaccessedtaxyes").prop("checked")) {
                DeclarantAssessedTax = true;
            }
            else if ($("#rbaccessedtaxno").prop("checked")) {
                DeclarantAssessedTax = false;
            }

            form60.RegistrationId = localStorage.getItem('registrationId');
            form60.RegistrationHolderId = registrationHoldersId;
            form60.DeclarantDocuments = "";
            form60.DeclarantTransactionParticulars = $('#txttransactionparticulars').val().trim();
            form60.DeclarantAmountofTransaction = $('#txttransactionsamount').val().trim();
            form60.DeclarantAssessedTax = DeclarantAssessedTax;
            form60.DetailsOfIncomeTax = $('#txtdetailsofincometax').val().trim();
            form60.ReasonForNoPan = $('#txtreasonfornopan').val().trim();

            setPreloader(true);
            axios.post(form60Url(), form60, { headers: authHeader() })
                .then(res => {
                    if (res.data.responseCode == "OK") {
                        toggleTabVertical(tabId + 1);
                        setPreloader(false);
                    }
                    else {
                        ErrorMessage(res.data.responseMessage);
                        setPreloader(false);
                    }
                })
        }
        else if (tabId == 3) {
            if ($('#ddloccupationdetails :selected').text() == "Businessman") {

                if ($('#txtlineofnusiness').val().trim() == "") {
                    $('#txtlineofnusiness').focus();
                    ErrorMessage("Line of Business is required!");
                    return;
                }
                else if ($('#txtbusinessname').val().trim() == "") {
                    $('#txtbusinessname').focus();
                    ErrorMessage("Business Name is required!");
                    return;
                }
                else if ($('#txtstartbusinessdate').val().trim() == "") {
                    $('#txtstartbusinessdate').focus();
                    ErrorMessage("Date of starting business is required!");
                    return;
                }
                else if ($('#txtbussinessaddress1').val().trim() == "") {
                    $('#txtbussinessaddress1').focus();
                    ErrorMessage("Address1 required!");
                    return;
                }
                else if ($('#txtbussinessaddress2').val().trim() == "") {
                    $('#txtbussinessaddress2').focus();
                    ErrorMessage("Address2 required!");
                    return;
                }
            }

            if ($("#chktwowheeler").prop("checked")) {
                if ($('#txttwowheeleryear').val().trim() == "") {
                    $('#txttwowheeleryear').focus();
                    ErrorMessage("Two Wheeler year is required!");
                    return;
                }
                if (parseInt($('#txttwowheeleryear').val().trim()) > today.getFullYear()) {
                    $('#txttwowheeleryear').focus();
                    ErrorMessage("Two Wheeler year should be valid!");
                    return;
                }
            }
            if ($("#chkcar").prop("checked")) {
                if ($('#txtcaryear').val().trim() == "") {
                    $('#txtcaryear').focus();
                    ErrorMessage("Car year is required!");
                    return;
                }

                if (parseInt($('#txtcaryear').val().trim()) > today.getFullYear()) {
                    $('#txtcaryear').focus();
                    ErrorMessage("Car year should be valid!");
                    return;
                }
            }
            if ($("#chkother").prop("checked")) {
                if ($('#txtotheryear').val().trim() == "") {
                    $('#txtotheryear').focus();
                    ErrorMessage("Other year is required!");
                    return;
                }

                if (parseInt($('#txtotheryear').val().trim()) > today.getFullYear()) {
                    $('#txtotheryear').focus();
                    ErrorMessage("Other year should be valid!");
                    return;
                }
            }

            var BornNonIndia = '';
            var TaxResidenceNonIndia = '';
            var BusinessVehicleTwoWheeler = '';
            var BusinessVehicleCar = '';
            var BusinessVehicleOther = '';
            var BusinessTwoWheelerPurchaseYear = '';
            var BusinessCarPurchaseYear = '';
            var BusinessOtherPurchaseYear = '';
            var InterestedIn = '';
            var BusinessAssetDetails = '';

            if ($("#rbbornyes").prop("checked")) {
                BornNonIndia = "true";
            }
            else if ($("#rbbornno").prop("checked")) {
                BornNonIndia = "false";
            }

            if ($("#rbtaxresidenceyes").prop("checked")) {
                TaxResidenceNonIndia = "true";
            }
            else if ($("#rbtaxresidenceno").prop("checked")) {
                TaxResidenceNonIndia = "false";
            }

            if ($("#chktwowheeler").prop("checked")) {
                BusinessVehicleTwoWheeler = 'Two Wheeler';
                BusinessTwoWheelerPurchaseYear = $('#txttwowheeleryear').val();
            }
            if ($("#chkcar").prop("checked")) {
                BusinessVehicleCar = 'Car';
                BusinessCarPurchaseYear = $('#txtcaryear').val();
            }
            if ($("#chkother").prop("checked")) {
                BusinessVehicleOther = 'Other';
                BusinessOtherPurchaseYear = $('#txtotheryear').val();
            }

            if ($("#chkcommercialproperty").prop("checked")) {
                BusinessAssetDetails = BusinessAssetDetails + "Commercial Property" + ", ";
            }
            if ($("#chkhouse").prop("checked")) {
                BusinessAssetDetails = BusinessAssetDetails + "House" + ", ";
            }
            if ($("#chkplot").prop("checked")) {
                BusinessAssetDetails = BusinessAssetDetails + "Plot" + ", ";
            }
            if ($("#chkothers").prop("checked")) {
                BusinessAssetDetails = BusinessAssetDetails + "Others" + ", ";
            }

            if ($("#chktwowheeler").prop("checked")) {
                BusinessVehicleTwoWheeler = "Two Wheeler";
            }
            if ($("#chkcar").prop("checked")) {
                BusinessVehicleCar = "Car";
            }
            if ($("#chkother").prop("checked")) {
                BusinessVehicleOther = "Other";
            }

            if ($("#chkmutualfunds").prop("checked")) {
                InterestedIn = InterestedIn + "Mutual Funds" + ", ";
            }
            if ($("#chkhealthinsurance").prop("checked")) {
                InterestedIn = InterestedIn + "Health Insurance" + ", ";
            }
            if ($("#chkgeneralinsurance").prop("checked")) {
                InterestedIn = InterestedIn + "General Insurance" + ", ";
            }
            if ($("#chkdemat").prop("checked")) {
                InterestedIn = InterestedIn + "Demat" + ", ";
            }
            if ($("#chkpmsby").prop("checked")) {
                InterestedIn = InterestedIn + "Pradhan Mantri Suraksha Bima Yojana (PMSBY)" + ", ";
            }
            if ($("#chkpmjjby").prop("checked")) {
                InterestedIn = InterestedIn + "Pradhan Mantri Jeevan Jyoti Bima Yojana (PMJJBY)" + ", ";
            }

            additionalDetails.RegistrationId = localStorage.getItem('registrationId');
            additionalDetails.RegistrationHolderId = registrationHoldersId;
            additionalDetails.FundsExpectedOrigin = $('#ddlfundsforcredit :selected').text();
            additionalDetails.FundsUtilisationExpected = $('#ddlfundsbydebit :selected').text();
            additionalDetails.OtherBankAccounts = $('#ddlotherbanksaccounts :selected').text();
            additionalDetails.Turnover = $('#txtturnover').val().trim();
            additionalDetails.AverageIncome = $('#txtaverageincome').val().trim();
            additionalDetails.AverageBalance = $('#txtexpectedincome').val().trim();
            additionalDetails.Education = $('#ddleducation :selected').text();
            additionalDetails.Religion = $('#ddlreligion :selected').text();
            additionalDetails.OccupationDetails = $('#ddloccupationdetails :selected').text();
            additionalDetails.LineOfBusiness = $('#txtlineofnusiness').val().trim();
            additionalDetails.BusinessName = $('#txtbusinessname').val().trim();
            additionalDetails.BusinessStartDate = $('#txtstartbusinessdate').val();
            additionalDetails.BusinessAddress1 = $('#txtbussinessaddress1').val().trim();
            additionalDetails.BusinessAddress2 = $('#txtbussinessaddress2').val().trim();
            additionalDetails.BusinessAddress3 = $('#txtbussinessaddress3').val().trim();
            additionalDetails.BusinessTelNo = $('#txtofficecontact').val().trim();
            additionalDetails.BusinessMobileNo = $('#txtofficemobileno').val().trim();
            additionalDetails.BusinessAnnualIncome = $('#ddlannualincome :selected').text();
            additionalDetails.BusinessIncomeSource = $('#txtsourceofincome').val().trim();
            additionalDetails.BusinessWealthSource = $('#txtsourceofwealth').val().trim();
            additionalDetails.BusinessEstimatedValue = $('#ddlestimatedvalue :selected').text();
            additionalDetails.BusinessAssetDetails = BusinessAssetDetails;
            additionalDetails.BornNonIndia = BornNonIndia;
            additionalDetails.TaxResidenceNonIndia = TaxResidenceNonIndia;
            additionalDetails.BusinessVehicleTwoWheeler = BusinessVehicleTwoWheeler;
            additionalDetails.BusinessVehicleCar = BusinessVehicleCar;
            additionalDetails.BusinessVehicleOther = BusinessVehicleOther;
            additionalDetails.BusinessTwoWheelerPurchaseYear = BusinessTwoWheelerPurchaseYear;
            additionalDetails.BusinessCarPurchaseYear = BusinessCarPurchaseYear;
            additionalDetails.BusinessOtherPurchaseYear = BusinessOtherPurchaseYear;
            additionalDetails.BusinessCarMaker = $('#txtcarmaker').val().trim();
            additionalDetails.InterestedIn = InterestedIn;
            additionalDetails.caste = $('#caste :selected').text();
            additionalDetails.CustomerReasonId = validation.values.customerreasonid?.toString();

            setPreloader(true);
            axios.post(additionalDetailsUrl(), additionalDetails, { headers: authHeader() })
                .then(res => {
                    if (res.data.responseCode == "OK") {
                        toggleTabVertical(tabId + 1);
                        setPreloader(false);
                    }
                    else {
                        ErrorMessage(res.data.responseMessage);
                        setPreloader(false);
                    }
                })
        }
        else if (tabId == 4) {
            if ($("#chkTerms").prop('checked') == true) {

                const updateStatus = {
                    RegistrationId: localStorage.getItem('registrationId'),
                    RegistrationHolderId: registrationHoldersId
                };

                setPreloader(true);
                axios.post(updateAccountHoldersStatusUrl(), updateStatus, { headers: authHeader() })
                    .then(res => {
                        if (res.data.responseCode == "OK") {
                            history.push("/CreateNewAccount");
                            setPreloader(false);
                        }
                        else {
                            ErrorMessage(res.data.responseMessage);
                            setPreloader(false);
                        }
                    })
            }
            else {
                ErrorMessage("Please select Terms & conditions");
                $("#chkTerms").focus();
            }
        }
    }

    const [activeTabVartical, setoggleTabVertical] = useState(1)
    const [passedStepsVertical, setPassedStepsVertical] = useState([1])

    function toggleTabVertical(tab) {
        if (activeTabVartical !== tab) {
            var isForm_60_applicable = false;
            var modifiedSteps = [...passedStepsVertical, tab]
            
            if ($("#chkPAN").prop('checked') == true) {
                isForm_60_applicable = true;
            }            
            

            if (!isForm_60_applicable) {
                var data = [...passedStepsVertical, tab].filter(step => step !== 2);
                modifiedSteps = [...data]
            }

            if (tab >= 1 && tab <= 4) {
                setoggleTabVertical(tab)
                setPassedStepsVertical(modifiedSteps)
            }
        }
    }

    function FillAddress() {
        debugger;

        if ($("#chkSameAs").prop("checked")) {
            let comAddress1 = $('#txtCommunicationAddress1').val();
            let comAddress2 = $('#txtCommunicationAddress2').val();
            let comAddress3 = $('#txtCommunicationAddress3').val();
            let comCity = $('#txtCommunicationCity').val();
            let comPin = $('#txtCommunicationPincode').val();
            let comState = $('#ddlCommunicationState').val();

            $('#txtPermanentAddress1').val(comAddress1);
            $('#txtPermanentAddress2').val(comAddress2);
            $('#txtPermanentAddress3').val(comAddress3);
            $('#txtPermanentCity').val(comCity);
            $('#txtPermanentPincode').val(comPin);
            $('#ddlPermanentState').val(comState);

            validation.values.permanentaddress = comAddress1;
            validation.values.permanentaddress2 = comAddress2;
            validation.values.permanentaddress3 = comAddress3;
            validation.values.permanentstate = comState;
            validation.values.permanentcity = comCity;
            validation.values.permanentpincode = comPin;
            validation.setFieldTouched("permanentaddress", "")
            validation.setFieldTouched("permanentaddress2", "")
            validation.setFieldTouched("permanentaddress3", "")
            validation.setFieldTouched("permanentstate", "")
            validation.setFieldTouched("permanentcity", "")
            validation.setFieldTouched("permanentpincode", "")
        }
        else {
            $('#txtPermanentAddress1').val('');
            $('#txtPermanentAddress2').val('');
            $('#txtPermanentAddress3').val('');
            $('#txtPermanentCity').val('');
            $('#txtPermanentPincode').val('');
            $('#ddlPermanentState').val('');
            validation.values.permanentaddress = '';
            validation.values.permanentaddress2 = '';
            validation.values.permanentaddress3 = '';
            validation.values.permanentstate = '';
            validation.values.permanentcity = '';
            validation.values.permanentpincode = '';
        }
    }

    // Form validation
    const validation = useFormik({

        enableReinitialize: true,

        initialValues: {

            personalchoose: holdersData.title == null ? '' : holdersData.title,
            firstname: holdersData.firstName == null ? '' : holdersData.firstName,
            middlename: holdersData.middleName == null ? '' : holdersData.middleName,
            lastname: holdersData.lastName == null ? '' : holdersData.lastName,
            phoneno: holdersData.mobile == null ? '' : holdersData.mobile,
            mobilenobelongsTo: holdersData.mobileNoBelongsTo == null ? '' : holdersData.mobileNoBelongsTo,
            email: holdersData.email == null ? '' : holdersData.email,
            gender: holdersData.gender == null ? '' : holdersData.gender,
            occupation: holdersData.occupation == null ? '' : holdersData.occupation,
            dob: holdersData.dob == null ? '' : holdersData.dob,
            maritalstatus: holdersData.length == 0 ? '2' : holdersData.dob == null ? '2' : holdersData.maritalStatus,
            nationality: holdersData.length == 0 ? '1' : holdersData.dob == null ? '1' : holdersData.nationality,
            communicationaddress: holdersData.localAddress1 == null ? '' : holdersData.localAddress1,
            communicationaddress2: holdersData.localAddress2 == null ? '' : holdersData.localAddress2,
            communicationaddress3: holdersData.localAddress3 == null ? '' : holdersData.localAddress3,
            communicationstate: holdersData.localState == null ? '' : holdersData.localState,
            communicationcity: holdersData.localCity == null ? '' : holdersData.localCity,
            communicationpincode: holdersData.localPin == null ? '' : holdersData.localPin,
            permanentaddress: holdersData.permanentAddress1 == null ? '' : holdersData.permanentAddress1,
            permanentaddress2: holdersData.permanentAddress2 == null ? '' : holdersData.permanentAddress2,
            permanentaddress3: holdersData.permanentAddress3 == null ? '' : holdersData.permanentAddress3,
            permanentstate: holdersData.permanentState == null ? '' : holdersData.permanentState,
            permanentcity: holdersData.permanentCity == null ? '' : holdersData.permanentCity,
            permanentpincode: holdersData.permanentPin == null ? '' : holdersData.permanentPin,
            poi: '',
            poipoa: '',
            pan: holdersData.pan == null ? '' : holdersData.pan,
            panfile: '',
            poifilePath: holdersData.poiFilePath == null ? '' : holdersData.poiFilePath,
            customerid: holdersData.customerId == null ? '' : holdersData.customerId,
            ckycno: holdersData.ckycNo == null ? '' : holdersData.ckycNo,
            photofile: '',
            photofilepath: holdersData.photoFilePath == null ? '' : holdersData.photoFilePath,

            fatherchoose: holdersData.fatherTitle == null ? '' : holdersData.fatherTitle,
            fatherlastname: holdersData.fatherLastName == null ? '' : holdersData.fatherLastName,
            fatherfirstname: holdersData.fatherFirstName == null ? '' : holdersData.fatherFirstName,
            fathermiddlelame: holdersData.fatherMiddleName == null ? '' : holdersData.fatherMiddleName,
            motherchoose: holdersData.motherTitle == null ? '' : holdersData.motherTitle,
            motherlastname: holdersData.motherLastName == null ? '' : holdersData.motherLastName,
            motherfirstname: holdersData.motherFirstName == null ? '' : holdersData.motherFirstName,
            mothermiddlename: holdersData.motherMiddleName == null ? '' : holdersData.motherMiddleName,
            maidenchoose: holdersData.maidenTitle == null ? '' : holdersData.maidenTitle,
            maidenlastname: holdersData.maidenLastName == null ? '' : holdersData.maidenLastName,
            maidenfirstname: holdersData.maidenFirstName == null ? '' : holdersData.maidenFirstName,
            maidenmiddlename: holdersData.maidenMiddleName == null ? '' : holdersData.maidenMiddleName,

            relatedpersonchoose: holdersData.relatedPersonTitle == null ? '' : holdersData.relatedPersonTitle,
            relatedpersonlastname: holdersData.relatedPeronLastName == null ? '' : holdersData.relatedPeronLastName,
            relatedpersonfirstname: holdersData.relatedPeronFirstName == null ? '' : holdersData.relatedPeronFirstName,
            relatedpersonmiddlename: holdersData.relatedPeronMiddleName == null ? '' : holdersData.relatedPeronMiddleName,
            relatedpersonrelation: holdersData.relatedPersonCustomerRelation == null ? '' : holdersData.relatedPersonCustomerRelation,
            relatedpersonpan: holdersData.relatedPersonPANNo == null ? '' : holdersData.relatedPersonPANNo,
            relatedpersonaadhar: holdersData.relatedPersonAadhaarNo == null ? '' : holdersData.relatedPersonAadhaarNo,
            relatedcourt: holdersData.relatedPersonCourtOrderNo == null ? '' : holdersData.relatedPersonCourtOrderNo,

            transactionparticulars: holdersData.declarantTransactionParticulars == null ? '' : holdersData.declarantTransactionParticulars,
            transactionsamount: holdersData.declarantAmountofTransaction == null ? '' : holdersData.declarantAmountofTransaction,
            detailsofincometax: holdersData.detailsOfIncomeTax == null ? '' : holdersData.detailsOfIncomeTax,
            reasonfornopan: holdersData.reasonForNoPan == null ? '' : holdersData.reasonForNoPan,

            annualactivity: holdersData.turnover == null ? '' : holdersData.turnover,
            averageincome: holdersData.averageIncome == null ? '' : holdersData.averageIncome,
            expectedincome: holdersData.averageBalance == null ? '' : holdersData.averageBalance,
            officecontact: holdersData.businessTelNo == null ? '' : holdersData.businessTelNo,
            officemobileno: holdersData.businessMobileNo == null ? '' : holdersData.businessMobileNo,
            twowheeleryear: holdersData.businessVehicleTwoWheeler == "Two Wheeler" ? holdersData.businessTwoWheelerPurchaseYear == null ? '' : holdersData.businessTwoWheelerPurchaseYear : '',
            caryear: holdersData.businessVehicleCar == "Car" ? holdersData.businessCarPurchaseYear == null ? '' : holdersData.businessCarPurchaseYear : '',
            anyotheryear: holdersData.businessVehicleOther == "Other" ? holdersData.businessOtherPurchaseYear == null ? '' : holdersData.businessOtherPurchaseYear : '',
            annualincome: holdersData.businessAnnualIncome == null ? "" : configForAnnualIncome.filter(a => a.label === holdersData.businessAnnualIncome)[0].value,
            customerreasonid: holdersData.reason == null ? '' : reasonToBecomeCustomer?.filter(r => r.reason === holdersData.reason)[0].id,
            occupationdetails: '',
            caste: holdersData.caste == null ? '' : holdersData.caste,
            religion: holdersData.religion == null ? '' : holdersData.religion,
            businessname: holdersData.businessName == null ? '' : holdersData.businessName,
            sourceofincome: holdersData.businessIncomeSource == null ? '' : holdersData.businessIncomeSource,
        },
        validationSchema: Yup.object({

            personalchoose: Yup.string().required("Title required"),
            firstname: Yup.string().required("First Name required").matches(/^[A-Za-z ]+$/, "Enter character only!"),
            middlename: Yup.string().matches(/^[A-Za-z ]+$/, "Enter character only!"),
            lastname: Yup.string().matches(/^[A-Za-z ]+$/, "Enter character only!"),
            phoneno: Yup.string().required("Phone No. required"),
            mobilenobelongsTo: Yup.string().required("Mobile No. belongs to required"),
            gender: Yup.string().required("Gender required"),
            dob: Yup.string().required("Date of Birth required"),
            maritalstatus: Yup.string().required("Maratial Status required"),
            nationality: Yup.string().required("Nationality required"),
            occupation: Yup.string().required("Occupation required"),
            communicationaddress: Yup.string().required("Address 1 required"),
            communicationstate: Yup.string().required("State required"),
            communicationcity: Yup.string().required("City required").matches(/^[A-Za-z ]+$/, "Enter character only!"),
            communicationpincode: Yup.number().required("Pincode required"),
            permanentaddress: Yup.string().required("Address 1 required"),
            permanentstate: Yup.string().required("State required"),
            permanentcity: Yup.string().required("City required").matches(/^[A-Za-z ]+$/, "Enter character only!"),
            permanentpincode: Yup.number().required("Pincode required"),
            poi: Yup.string().required("POI required"),
            poipoa: Yup.string().required("POI/POA required"),
            pan: Yup.string().required("PAN No. required"),
            panfile: userAccountType && userAccountType === 5 ? Yup.string() : Yup.string().required("PAN document required"),
            photofile: userAccountType && userAccountType === 5 ? Yup.string() : Yup.string().required("Photo required"),

            transactionparticulars: Yup.string().required("Transaction Particulars required"),
            transactionsamount: Yup.string().required("Amount of Transactions required"),
            detailsofincometax: Yup.string().required("Details of income required"),
            reasonfornopan: Yup.string().required("Reason for not having PAN required"),

            annualactivity: Yup.string().required("Annual activity/ A/c turnover required"),
            averageincome: Yup.string().required("Average income required"),
            expectedincome: Yup.string().required("Expected average balance required"),
            annualincome: Yup.string().required("Annual income required"),
            officemobileno: Yup.string(),
            customerreasonid: Yup.string().required("Reason required"),
            occupationdetails: Yup.string().required("Occupation details required"),
            caste: Yup.string().required("Case required"),
            religion: Yup.string().required("Religion required"),
            businessname: Yup.string().required("Name of the employer/firm/institution required"),
            sourceofincome: Yup.string().required("Source of income required"),
        }),

        onSubmit: (values) => {
            //console.log("values", values);
        }
    });

    // ---- Old code for setting occupation in additional details section ----
    // useEffect(() => {
    //     if (occupationData?.length) {
    //         const occupationDetails = holdersData?.occupationDetails;
    //         const occupation = holdersData?.occupation || validation.values.occupation;
            
    //         const od_id = occupationData.find(oc => oc.occupationName === occupationDetails);
    
    //         const final_id = occupationDetails ? od_id?.id : occupation;
            
    //         if (final_id !== undefined && final_id !== null) {
    //             validation.setFieldValue("occupationdetails", final_id);
    //         }
    //     }
    // }, [occupationData, holdersData, validation.values.occupation])


    // ---- New implementation for setting occupation in additional details section ----
    useEffect(() => {
        if (!occupationData?.length || !holdersData?.occupationDetails) return;

        const matched = occupationData.find(
            oc => oc.occupationName === holdersData.occupationDetails
        );

        if (matched?.id) {
            validation.setFieldValue("occupationdetails", String(matched.id));
        }
    }, [occupationData, holdersData]);


    useEffect(() => {
        if (Object.keys(location) && location?.state) {
            const { accountType } = location?.state;
            setUserAccountType(accountType || null)
        }
    }, [location])


    function BindPOIPOA(data) {
        debugger;
        var listPOI = [];

        if (data.length > 0) {
            if (data[0].poi != null) {
                data.map(p => {
                    var rowsInput = {
                        poiid: p.poiId.toString(),
                        SelectedProofofIdentity: p.poi,
                        EnterNumber: p.poiNo,
                        POIPOA: p.poipoa,
                        Expiry: p.expiryDate == null ? '' : p.expiryDate,
                        Upload: '',
                        poifilepath: p.poiFilePath,
                        poifilepathurl: getAPIUrl() + "/POIFiles/" + p.poiFilePath,
                        Delete: ''
                    }
                    listPOI.push(rowsInput);
                })

                setRowsData(listPOI);
            }
        }
    }

    // Form error check for personal details section
    const showErrorsOnPersonalDetailForm = () => {
        if (validation.submitCount > 0 && Object.keys(validation.errors).length > 0) {
            const firstErrorKey = Object.keys(validation.errors)[0];
            const element = document.querySelector(`[name="${firstErrorKey}"]`);
            // console.log("element => ", element)
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }

    // Form error check for additional details section
    const showErrorsOnAdditionalDetailForm = () => {
        const scrollableFields = ["annualactivity", "averageincome", "expectedincome", "officemobileno", "annualincome", "customerreasonid"];
        if (validation.submitCount > 0 && Object.keys(validation.errors).length > 0) {
            const errorFieldToScroll = scrollableFields.find(
              (field) => validation.errors[field]
            );
        
            if (errorFieldToScroll) {
              const el = document.querySelector(`[name="${errorFieldToScroll}"]`);
              if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
              }
            }
        }
    }

    function CheckIsValid(controlValues) {
        debugger;
        var x = Object.keys(controlValues[0])
        var isCheckIfUndefined = x.map(p => {
            if (controlValues[0][p] === "" || controlValues[0][p] === undefined) {
                if ((p == "pan" && controlValues[0][p] == "" && $("#chkPAN").prop('checked')) || (p == "panfile" && controlValues[0][p] == "" && $("#chkPAN").prop('checked'))) {
                    return false;
                }
                else if (p == "panfile" && validation.values.poifilePath != '' && !$("#chkPAN").prop('checked')) {
                    return false;
                }
                else if (p == "photofile" && validation.values.photofilepath != '') {
                    return false;
                }
                else if (p == "panfile" && validation.values.poifilePath == '' && !$("#chkPAN").prop('checked')) {
                    return true;
                }
                else if (p == "photofile" && validation.values.photofilepath == '') {
                    return true;
                }
                else if (p == "email") {
                    return false;
                }
                return true;
            }
            else
                return false;
        })

        var checkResponse = isCheckIfUndefined.includes(true)

        if (activeTabVartical === 1 && checkResponse) showErrorsOnPersonalDetailForm();
        if (activeTabVartical === 3 && checkResponse) showErrorsOnAdditionalDetailForm();

        return checkResponse
    }

    //$(".d-block").flatpickr({
    //    dateFormat: "d-M-Y",
    //    maxDate: "today"
    //});
    // $(".d-block").flatpickr({
    //     dateFormat: "d-M-Y",
    //     altFormat: "F j, Y",
    //     maxDate: "today",
    //     disableMobile: "true"
    // });

    // $(".maxFuture").flatpickr({
    //     dateFormat: "d-M-Y",
    //     disableMobile: "true"
    // });

    const tabHeading = {
        color: "#9a084f",
        fontWeight: "bold"
    }

    const label = {
        color: "black"
    }

    const formBackground = {
        borderRadius: 8,
        flex: 1,
        //backgroundColor: "rgb(247 242 242)",
        padding: "15px"
    }

    const cardBackground = {
        borderRadius: 8,
        flex: 1,
        //backgroundColor: "rgb(247 242 242)",
    }

    const formButton = {
        marginLeft: "20px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    const formButtonFirstPage = {
        marginLeft: "15px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    const formMandatory = {
        color: "red",
        fontWeight: "bold"
    }

    // Function to handle mobile no. belongs to field
    const handleMobileNoBelongsTo = (event) => {
        const { name, checked } = event?.target;
        const value = name === "self" ? "Self" : name === "familymembers" ? "Family Members" : "Others";
        if (checked) {
            const ev = {
                ...event,
                target: {
                    ...event.target,
                    name: "mobilenobelongsTo",
                    value: value
                }
            }
            validation.handleChange(ev)
        }
    }

    // Function to check the options is selected or not
    const showNoteOnTaxYesOrBornYes = () => {
        let taxNonIndia = false;
        let bornNonIndia = false;
        
        if ($("#rbtaxresidenceyes").prop("checked")) {
            taxNonIndia = true;
        } else {
            taxNonIndia = false;
        }

        if ($("#rbbornyes").prop("checked")) {
            bornNonIndia = true;
        } else {
            bornNonIndia = false;
        }

        return {
            taxNonIndia: taxNonIndia,
            bornNonIndia: bornNonIndia
        }
    }

    // const resultOfFatca = showNoteOnTaxYesOrBornYes();
    const handleRadioButtonChange = () => {
        const result = showNoteOnTaxYesOrBornYes();
        setResultOfFatca(result);
    };

    useEffect(() => {
        $("#rbtaxresidenceyes, #rbbornyes").on("change", handleRadioButtonChange);

         // Delay to wait for DOM to be ready
        setTimeout(() => {
            handleRadioButtonChange();
        }, 200);
      
        // Clean up
        return () => {
          $("#rbtaxresidenceyes, #rbbornyes").off("change", handleRadioButtonChange);
        };
    }, []);

    // Function to auto-calculate Annual Income & A/C Turnover
    function getAnnualIncomeDetails(monthlyIncome) {
        if (!monthlyIncome || isNaN(monthlyIncome) || monthlyIncome < 0) {
            return {
                annualIncomeValue: "", // default value
                annualTurnover: 0
            };
        }

        const annualIncome = monthlyIncome * 12;
        const annualTurnover = annualIncome * 2;

        // Match monthlyIncome to config ranges
        let annualIncomeValue = configForAnnualIncome[configForAnnualIncome.length - 1].value; // default to "Above 2500000"

        for (let i = 1; i < configForAnnualIncome.length; i++) {
            const { label, value } = configForAnnualIncome[i];

            if (label.includes("Upto")) {
                const max = parseInt(label.match(/\d+/)[0]);
                if (annualIncome <= max) {
                    annualIncomeValue = value;
                    break;
                }
            } else if (label.includes("to")) {
                const [min, max] = label.match(/\d+/g).map(Number);
                if (annualIncome >= min && annualIncome <= max) {
                    annualIncomeValue = value;
                    break;
                }
            } else if (label.includes("Above")) {
                const min = parseInt(label.match(/\d+/)[0]);
                if (annualIncome > min) {
                    annualIncomeValue = value;
                    break;
                }
            }
        }

        return {
            annualIncomeValue,
            annualTurnover
        };
    }

    return (
        <React.Fragment>
            <div id="preloader">
                <div id="status">
                    <div className="spinner-chase">
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                    </div>
                </div>
            </div>

            <MetaTags>
                <title>JSB-Other Holder</title>
            </MetaTags>
            <Container fluid={true}>
                <Row>
                    <Col lg="12">
                        <Card style={{ width: "100%" }}>
                            <CardBody>
                                <div className="wizard clearfix">
                                    <div className="steps clearfix" style={{ marginTop: "-15px" }}>
                                        <ul>
                                            <NavItem
                                                className={classnames({
                                                    current: activeTabVartical === 1,
                                                })}
                                            >
                                                <NavLink
                                                    className={classnames({
                                                        active: activeTabVartical === 1,
                                                    })}
                                                    onClick={() => {
                                                        toggleTabVertical(1)
                                                    }}
                                                    disabled={!(passedStepsVertical || []).includes(1)}
                                                >
                                                    <span className="number">1</span> Personal Details
                                                </NavLink>
                                            </NavItem>
                                            <NavItem
                                                className={classnames({
                                                    current: activeTabVartical === 2,
                                                })}
                                            >
                                                <NavLink id="navForm60"
                                                    className={classnames({
                                                        active: activeTabVartical === 2,
                                                    })}
                                                    onClick={() => {
                                                        toggleTabVertical(2)
                                                    }}
                                                    disabled={!(passedStepsVertical || []).includes(2)}
                                                >
                                                    <span className="number">2</span>{" "}
                                                    <span>Form no 60/61</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem
                                                className={classnames({
                                                    current: activeTabVartical === 3,
                                                })}
                                            >
                                                <NavLink
                                                    className={
                                                        (classnames({
                                                            active: activeTabVartical === 3,
                                                        }),
                                                            "done")
                                                    }
                                                    onClick={() => {
                                                        toggleTabVertical(3)
                                                    }}
                                                    disabled={!(passedStepsVertical || []).includes(3)}
                                                >
                                                    <span className="number">3</span> Additional Details
                                                </NavLink>
                                            </NavItem>
                                            <NavItem
                                                className={classnames({
                                                    current: activeTabVartical === 4,
                                                })}
                                            >
                                                <NavLink
                                                    className={
                                                        (classnames({
                                                            active: activeTabVartical === 4,
                                                        }),
                                                            "done")
                                                    }
                                                    onClick={() => {
                                                        toggleTabVertical(4)
                                                    }}
                                                    disabled={!(passedStepsVertical || []).includes(4)}
                                                >
                                                    <span className="number">4</span>Declaration
                                                </NavLink>
                                            </NavItem>
                                        </ul>
                                    </div>

                                    <div className="content clearfix" style={{ marginTop: "-20px", width: "100%" }}>
                                        <TabContent
                                            activeTab={activeTabVartical}
                                            className="body" >
                                            <TabPane tabId={1}>
                                                <Form style={formBackground} className="registration needs-validation" encType="multipart/form-data" onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}>
                                                    <Form className="needs-validation" style={{ width: "100%" }} encType="multipart/form-data">
                                                        <div>
                                                            <Row>
                                                                <Col lg="2">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Customer ID</label>
                                                                        <Input
                                                                            name="customerid"
                                                                            placeholder="Customer ID"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtCustomerID"
                                                                            maxLength="20"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.customerid || ""}
                                                                            autocomplete="off"
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="2">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>CKYC Number</label>
                                                                        <Input
                                                                            name="ckycno"
                                                                            placeholder="CKYC Number"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtCKYCNumber"
                                                                            maxLength="20"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.ckycno || ""}
                                                                            autocomplete="off"
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <label style={label}>Upload Photo</label>{userAccountType !== 5 && (<span style={formMandatory}>*</span>)}
                                                                    <small style={{ marginLeft: "3px", fontSize: '80%' }}>(Kindly upload document in JPG,JPEG,PNG format only)</small>
                                                                    <Input multiple="" id="UploadPhoto" name="photofile" type="file" accept=".jpg,.jpeg,.png"
                                                                        value={validation.values.photofile || ""}
                                                                        // onChange={e => { validation.handleChange(e); handlePhotoUpload(e) }}
                                                                        onChange={handlePhotoUpload}
                                                                        invalid={
                                                                            validation.touched.photofile && validation.errors.photofile && validation.values.photofilepath == '' ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.photofile && validation.errors.photofile && validation.values.photofilepath == '' ? (
                                                                        <FormFeedback type="invalid">{validation.errors.photofile}</FormFeedback>
                                                                    ) : null}
                                                                </Col>
                                                                <Col lg="2" style={{ marginTop: "35px", fontSize: "medium", fontWeight: "bold" }}>
                                                                    <a id="lnkPhotoDownload" href="" target="_blank" rel="noreferrer" style={{ visibility: "hidden" }}
                                                                        onClick={() => {

                                                                        }} >
                                                                        <i className="bx bx-show" style={{ fontSize: "xx-large", marginTop: "-5px" }}></i>
                                                                    </a>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        <div style={{ borderColor: "black", padding: "10px" }}>
                                                            <Label><h5 style={tabHeading}>Personal details</h5></Label>
                                                            <br></br>
                                                            <Row>
                                                                <Col lg="2">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Title</label><span style={formMandatory}>*</span>
                                                                        <Input type="select"
                                                                            className="form-select"
                                                                            name="personalchoose"
                                                                            id="ddlpersonalchoose"
                                                                            onChange={validation.handleChange}
                                                                            value={validation.values.personalchoose || ""}
                                                                            invalid={
                                                                                validation.touched.personalchoose && validation.errors.personalchoose ? true : false
                                                                            }
                                                                        >
                                                                            <option value="">Title</option>
                                                                            <option value="1">Mr.</option>
                                                                            <option value="2">Mrs.</option>
                                                                            <option value="3">Miss.</option>
                                                                            <option value="4">Smt.</option>
                                                                            <option value="5">Ms.</option>
                                                                            <option value="6">Master</option>
                                                                        </Input>
                                                                        {validation.touched.personalchoose && validation.errors.personalchoose ? (
                                                                            <FormFeedback type="invalid">{validation.errors.personalchoose}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="3">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Last Name</label>
                                                                        <Input
                                                                            name="lastname"
                                                                            placeholder="Last Name"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtLastName"
                                                                            maxLength="50"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.lastname || ""}
                                                                            style={{ textTransform: "capitalize" }}
                                                                            // invalid={
                                                                            //     validation.touched.lastname && validation.errors.lastname ? true : false
                                                                            // }
                                                                            autocomplete="off"
                                                                        />
                                                                        {/* {validation.touched.lastname && validation.errors.lastname ? (
                                                                            <FormFeedback type="invalid">{validation.errors.lastname}</FormFeedback>
                                                                        ) : null} */}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="3">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>First Name</label><span style={formMandatory}>*</span>
                                                                        <Input
                                                                            name="firstname"
                                                                            placeholder="First Name"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtFirstName"
                                                                            maxLength="50"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.firstname || ""}
                                                                            style={{ textTransform: "capitalize" }}
                                                                            invalid={
                                                                                validation.touched.firstname && validation.errors.firstname ? true : false
                                                                            }
                                                                            autocomplete="off"
                                                                        />
                                                                        {validation.touched.firstname && validation.errors.firstname ? (
                                                                            <FormFeedback type="invalid">{validation.errors.firstname}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="2">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Middle Name</label>
                                                                        <Input
                                                                            name="middlename"
                                                                            placeholder="Middle Name"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtMiddleName"
                                                                            maxLength="50"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.middlename || ""}
                                                                            style={{ textTransform: "capitalize" }}
                                                                            // invalid={
                                                                            //     validation.touched.middlename && validation.errors.middlename ? true : false
                                                                            // }
                                                                            autocomplete="off"
                                                                        />
                                                                        {/* {validation.touched.middlename && validation.errors.middlename ? (
                                                                            <FormFeedback type="invalid">{validation.errors.middlename}</FormFeedback>
                                                                        ) : null} */}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="2">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Gender</label><span style={formMandatory}>*</span>
                                                                        <Input type="select"
                                                                            name="gender"
                                                                            className="form-select"
                                                                            id="ddlgender"
                                                                            onChange={validation.handleChange}
                                                                            value={validation.values.gender || ""}
                                                                            invalid={
                                                                                validation.touched.gender && validation.errors.gender ? true : false
                                                                            }
                                                                        >
                                                                            <option value="">Gender</option>
                                                                            <option value="1">Male</option>
                                                                            <option value="2">Female</option>
                                                                            <option value="3">Transgender</option>
                                                                        </Input>
                                                                        {validation.touched.gender && validation.errors.gender ? (
                                                                            <FormFeedback type="invalid">{validation.errors.gender}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg="2">
                                                                    <FormGroup className=" mb-3">
                                                                        <label style={label}>Birth Date</label><span style={formMandatory}>*</span>
                                                                            <div className={validation.touched.dob && validation.errors.dob ? "flatpickr-error-style" : "flatpickr"}>
                                                                                <Flatpickr
                                                                                    id="txtdob"
                                                                                    name="dob"
                                                                                    placeholder="Birth Date"
                                                                                    className={`form-control flatpickr ${
                                                                                        validation.touched.dob && validation.errors.dob
                                                                                            ? "is-invalid"
                                                                                            : ""
                                                                                        }`}
                                                                                    onBlur={validation.handleBlur}
                                                                                    onChange={([selectedDate], dateStr) => {
                                                                                        validation.setFieldValue("dob", dateStr);
                                                                                    }}
                                                                                    options={{
                                                                                        dateFormat: "d-M-Y",
                                                                                        altFormat: "F j, Y",
                                                                                        maxDate: "today",
                                                                                        disableMobile: "true",
                                                                                    }}
                                                                                    value={validation.values.dob || ""}
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                {validation.touched.dob && validation.errors.dob ? (
                                                                                    <span style={{fontSize: '11px'}} className="text-danger">{validation.errors.dob}</span>
                                                                                ) : null}
                                                                            </div>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="3">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Marital Status</label><span style={formMandatory}>*</span>
                                                                        <Input type="select"
                                                                            name="maritalstatus"
                                                                            defaultValue={2}
                                                                            className="form-select"
                                                                            id="ddlmaratialstatus"
                                                                            onChange={validation.handleChange}
                                                                            value={validation.values.maritalstatus || ""}
                                                                            invalid={
                                                                                validation.touched.maritalstatus && validation.errors.maritalstatus ? true : false
                                                                            }
                                                                        >
                                                                            <option value="">Marital status</option>
                                                                            <option value="1">Married</option>
                                                                            <option value="2">Unmarried</option>
                                                                            <option value="3">Divorce</option>
                                                                        </Input>
                                                                        {validation.touched.maritalstatus && validation.errors.maritalstatus ? (
                                                                            <FormFeedback type="invalid">{validation.errors.maritalstatus}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="3">
                                                                    <FormGroup className=" mb-3">
                                                                        <label style={label}>Email</label>
                                                                        <Input
                                                                            name="email"
                                                                            placeholder="Email"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtEmailID"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={e => { validation.handleChange(e); emailValidation(e) }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.email || ""}
                                                                            maxLength="100"
                                                                            autocomplete="off"
                                                                        />
                                                                        <h10 style={{
                                                                            color: 'red',
                                                                            fontSize: '80%'
                                                                        }}>{emailError}</h10>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="2">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Nationality</label><span style={formMandatory}>*</span>
                                                                        <Input type="select"
                                                                            className="form-select"
                                                                            name="nationality"
                                                                            id="ddlnationality"
                                                                            onChange={validation.handleChange}
                                                                            value={validation.values.nationality || ""}
                                                                            invalid={
                                                                                validation.touched.nationality && validation.errors.nationality ? true : false
                                                                            }
                                                                        >
                                                                            <option value="">Nationality</option>
                                                                            <option value="1">Indian</option>
                                                                            <option value="2">NRI/PIO</option>
                                                                            <option value="3">Others</option>

                                                                        </Input>
                                                                        {validation.touched.nationality && validation.errors.nationality ? (
                                                                            <FormFeedback type="invalid">{validation.errors.nationality}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>

                                                                </Col>
                                                                <Col lg="2">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Occupation</label><span style={formMandatory}>*</span>
                                                                        <Input type="select"
                                                                            className="form-select"
                                                                            name="occupation"
                                                                            id="ddloccupation"
                                                                            onChange={(e) => {
                                                                                const { value } = e.target;
                                                                                validation.handleChange(e);
                                                                                validation.setFieldValue("occupationdetails", value);
                                                                            }}
                                                                            value={validation.values.occupation || ""}
                                                                            invalid={
                                                                                validation.touched.occupation && validation.errors.occupation ? true : false
                                                                            }
                                                                        >
                                                                            <option value="">Occupation</option>
                                                                            {
                                                                                occupationData.map((value, key) => (
                                                                                    <option key={value.id} value={value.id}>
                                                                                        {value.occupationName}
                                                                                    </option>
                                                                                ))
                                                                            }
                                                                        </Input>
                                                                        {validation.touched.occupation && validation.errors.occupation ? (
                                                                            <FormFeedback type="invalid">{validation.errors.occupation}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg="2">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Mobile</label><span style={formMandatory}>*</span>
                                                                        <InputGroup>
                                                                            <div className="input-group-text">+91</div>
                                                                            <Input
                                                                                name="phoneno"
                                                                                placeholder="Mobile"
                                                                                type="text"
                                                                                className="form-control"
                                                                                id="txtPhoneno"
                                                                                maxLength="10"
                                                                                onKeyPress={e => {
                                                                                    if (e.key === 'Enter') e.preventDefault()
                                                                                }}
                                                                                onChange={e => { chkNumeric(e) }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.phoneno || ""}
                                                                                invalid={
                                                                                    validation.touched.phoneno && validation.errors.phoneno ? true : false
                                                                                }
                                                                                autocomplete="off"
                                                                            />
                                                                        </InputGroup>
                                                                        {validation.touched.phoneno && validation.errors.phoneno ? (
                                                                            <FormFeedback type="invalid">{validation.errors.phoneno}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="3">
                                                                    <FormGroup>
                                                                        <label style={label}>Mobile No belongs to</label><span style={formMandatory}>*</span>{" "}
                                                                        {validation.touched.mobilenobelongsTo && validation.errors.mobilenobelongsTo ? (
                                                                            <label className="text-danger" style={{fontSize: '11px'}}>(Required)</label>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                    <div className="d-flex align-items-center gap-4">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                name="self"
                                                                                id="chkself"
                                                                                onChange={handleMobileNoBelongsTo}
                                                                                onBlur={validation.handleBlur}
                                                                                checked={validation.values.mobilenobelongsTo === "Self" ? true : false}
                                                                                invalid={
                                                                                    validation.touched.mobilenobelongsTo && validation.errors.mobilenobelongsTo ? true : false
                                                                                }
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                Self
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                name="familymembers"
                                                                                id="chkfamilymembers"
                                                                                onChange={handleMobileNoBelongsTo}
                                                                                onBlur={validation.handleBlur}
                                                                                checked={validation.values.mobilenobelongsTo === "Family Members" ? true : false}
                                                                                invalid={
                                                                                    validation.touched.mobilenobelongsTo && validation.errors.mobilenobelongsTo ? true : false
                                                                                }
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                Family Members
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                name="others"
                                                                                id="chkothers"
                                                                                onChange={handleMobileNoBelongsTo}
                                                                                onBlur={validation.handleBlur}
                                                                                checked={validation.values.mobilenobelongsTo === "Others" ? true : false}
                                                                                invalid={
                                                                                    validation.touched.mobilenobelongsTo && validation.errors.mobilenobelongsTo ? true : false
                                                                                }
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                Others
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <FormGroup className="mb-3">
                                                                    <Label style={label}>Communication Address</Label>
                                                                </FormGroup>
                                                            </Row>
                                                            <Row>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Address 1</label><span style={formMandatory}>*</span>
                                                                        <Input
                                                                            name="communicationaddress"
                                                                            placeholder="Address 1"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtCommunicationAddress1"
                                                                            maxLength="300"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.communicationaddress || ""}
                                                                            invalid={
                                                                                validation.touched.communicationaddress && validation.errors.communicationaddress ? true : false
                                                                            }
                                                                            autocomplete="off"
                                                                        />
                                                                        {validation.touched.communicationaddress && validation.errors.communicationaddress ? (
                                                                            <FormFeedback type="invalid">{validation.errors.communicationaddress}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Address 2</label>
                                                                        <Input
                                                                            name="communicationaddress2"
                                                                            placeholder="Address 2"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtCommunicationAddress2"
                                                                            maxLength="300"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.communicationaddress2 || ""}
                                                                            autocomplete="off"
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Address 3</label>
                                                                        <Input
                                                                            name="communicationaddress3"
                                                                            placeholder="Address 3"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtCommunicationAddress3"
                                                                            maxLength="300"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.communicationaddress3 || ""}
                                                                            autocomplete="off"
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>City</label><span style={formMandatory}>*</span>
                                                                        <Input
                                                                            name="communicationcity"
                                                                            placeholder="City"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtCommunicationCity"
                                                                            maxLength="50"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.communicationcity || ""}
                                                                            invalid={
                                                                                validation.touched.communicationcity && validation.errors.communicationcity ? true : false
                                                                            }
                                                                            autocomplete="off"
                                                                        />
                                                                        {validation.touched.communicationcity && validation.errors.communicationcity ? (
                                                                            <FormFeedback type="invalid">{validation.errors.communicationcity}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Pin</label><span style={formMandatory}>*</span>
                                                                        <Input
                                                                            name="communicationpincode"
                                                                            placeholder="Pin"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtCommunicationPincode"
                                                                            maxLength="6"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={e => { chkNumeric(e) }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.communicationpincode || ""}
                                                                            invalid={
                                                                                validation.touched.communicationpincode && validation.errors.communicationpincode ? true : false
                                                                            }
                                                                            autocomplete="off"
                                                                        />
                                                                        {validation.touched.communicationpincode && validation.errors.communicationpincode ? (
                                                                            <FormFeedback type="invalid">{validation.errors.communicationpincode}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>State</label><span style={formMandatory}>*</span>
                                                                        <Input type="select"
                                                                            className="form-select"
                                                                            name="communicationstate"
                                                                            id="ddlCommunicationState"
                                                                            onChange={validation.handleChange}
                                                                            value={validation.values.communicationstate || ""}
                                                                            invalid={
                                                                                validation.touched.communicationstate && validation.errors.communicationstate ? true : false
                                                                            }
                                                                        >
                                                                            <option value="">State</option>
                                                                            {
                                                                                stateData.map((value, key) => (
                                                                                    <option key={value.id} value={value.id}>
                                                                                        {value.stateName}
                                                                                    </option>
                                                                                ))
                                                                            }
                                                                        </Input>
                                                                        {validation.touched.communicationstate && validation.errors.communicationstate ? (
                                                                            <FormFeedback type="invalid">{validation.errors.communicationstate}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <FormGroup className="mb-3">
                                                                    <Row>
                                                                        <Col lg="12">
                                                                            <FormGroup className="mb-3">
                                                                                <div className="form-check">
                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        id="chkSameAs"
                                                                                        onClick={() => {
                                                                                            FillAddress()
                                                                                        }}
                                                                                    />
                                                                                    <Label style={label}
                                                                                        className="form-check-label"
                                                                                        htmlFor="invalidCheck"
                                                                                    >
                                                                                        {" "}
                                                                                        Same as above
                                                                                    </Label>
                                                                                </div>
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Label style={label}>Permanent Address</Label>
                                                                </FormGroup>
                                                            </Row>
                                                            <Row>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Address 1</label><span style={formMandatory}>*</span>
                                                                        <Input
                                                                            name="permanentaddress"
                                                                            placeholder="Address 1"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtPermanentAddress1"
                                                                            maxLength="300"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.permanentaddress || ""}
                                                                            invalid={
                                                                                validation.touched.permanentaddress && validation.errors.permanentaddress ? true : false
                                                                            }
                                                                            autocomplete="off"
                                                                        />
                                                                        {validation.touched.permanentaddress && validation.errors.permanentaddress ? (
                                                                            <FormFeedback type="invalid">{validation.errors.permanentaddress}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Address 2</label>
                                                                        <Input
                                                                            name="permanentaddress2"
                                                                            placeholder="Address 2"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtPermanentAddress2"
                                                                            maxLength="300"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.permanentaddress2 || ""}
                                                                            autocomplete="off"
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Address 3</label>
                                                                        <Input
                                                                            name="permanentaddress3"
                                                                            placeholder="Address 3"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtPermanentAddress3"
                                                                            maxLength="300"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.permanentaddress3 || ""}
                                                                            autocomplete="off"
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>City</label><span style={formMandatory}>*</span>
                                                                        <Input
                                                                            name="permanentcity"
                                                                            placeholder="City"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtPermanentCity"
                                                                            maxLength="50"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.permanentcity || ""}
                                                                            invalid={
                                                                                validation.touched.permanentcity && validation.errors.permanentcity ? true : false
                                                                            }
                                                                            autocomplete="off"
                                                                        />
                                                                        {validation.touched.permanentcity && validation.errors.permanentcity ? (
                                                                            <FormFeedback type="invalid">{validation.errors.permanentcity}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Pin</label><span style={formMandatory}>*</span>
                                                                        <Input
                                                                            name="permanentpincode"
                                                                            placeholder="Pin"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtPermanentPincode"
                                                                            maxLength="6"
                                                                            onKeyPress={e => {
                                                                                if (e.key === 'Enter') e.preventDefault()
                                                                            }}
                                                                            onChange={e => { chkNumeric(e) }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.permanentpincode || ""}
                                                                            invalid={
                                                                                validation.touched.permanentpincode && validation.errors.permanentpincode ? true : false
                                                                            }
                                                                            autocomplete="off"
                                                                        />
                                                                        {validation.touched.permanentpincode && validation.errors.permanentpincode ? (
                                                                            <FormFeedback type="invalid">{validation.errors.permanentpincode}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>State</label><span style={formMandatory}>*</span>
                                                                        <Input type="select"
                                                                            className="form-select"
                                                                            name="permanentstate"
                                                                            id="ddlPermanentState"
                                                                            onChange={validation.handleChange}
                                                                            value={validation.values.permanentstate || ""}
                                                                            invalid={
                                                                                validation.touched.permanentstate && validation.errors.permanentstate ? true : false
                                                                            }
                                                                        >
                                                                            <option value="">State</option>
                                                                            {
                                                                                stateData.map((value, key) => (
                                                                                    <option key={value.id} value={value.id}>
                                                                                        {value.stateName}
                                                                                    </option>
                                                                                ))
                                                                            }
                                                                        </Input>
                                                                        {validation.touched.permanentstate && validation.errors.permanentstate ? (
                                                                            <FormFeedback type="invalid">{validation.errors.permanentstate}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <br></br>

                                                            <Row>
                                                                <Col lg="4">
                                                                    <label style={label}>PAN</label><span style={formMandatory}>*</span>
                                                                    <Input
                                                                        placeholder="PAN No."
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtPancard"
                                                                        maxLength="10"
                                                                        name="pan"
                                                                        onKeyPress={e => {
                                                                            if (e.key === 'Enter') e.preventDefault()
                                                                        }}
                                                                        onChange={validation.handleChange}
                                                                        value={validation.values.pan || ""}
                                                                        invalid={
                                                                            validation.errors.pan && !$("#chkPAN").prop('checked') &&
                                                                                (validation.touched.pan && !$("#chkPAN").prop('checked')) ? true : false
                                                                        }
                                                                        autocomplete="off"
                                                                    />
                                                                    <h10 style={{
                                                                        color: 'red',
                                                                        fontSize: '80%'
                                                                    }}>{panError}</h10>
                                                                    {
                                                                        validation.errors.pan && !$("#chkPAN").prop('checked') &&
                                                                            (validation.touched.pan && !$("#chkPAN").prop('checked')) ? (
                                                                            <FormFeedback type="invalid">{validation.errors.pan}</FormFeedback>
                                                                        ) : null}
                                                                    <Input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        id="chkPAN" onClick={() => disablePAN()} /><small style={{ marginLeft: "5px" }}>Fill Form 60/61 if PAN is not available</small>
                                                                </Col>
                                                                <Col lg="4">
                                                                    <label style={label}>Upload PAN</label>{userAccountType !== 5 && (<span style={formMandatory}>*</span>)}
                                                                    <small style={{ marginLeft: "3px", fontSize: '85%' }}>(Kindly upload document in JPG,JPEG,PNG format only)</small>
                                                                    <Input multiple="" id="Upload" name="panfile" type="file" accept=".jpg,.jpeg,.png"
                                                                        value={validation.values.panfile || ""}
                                                                        // onChange={e => { validation.handleChange(e); handleUpload(e) }}
                                                                        onChange={handleUpload}
                                                                        invalid={
                                                                            validation.errors.panfile && !$("#chkPAN").prop('checked') && validation.values.poifilePath == '' &&
                                                                                (validation.touched.panfile && !$("#chkPAN").prop('checked')) ? true : false
                                                                        }
                                                                    />
                                                                    {
                                                                        validation.errors.panfile && !$("#chkPAN").prop('checked') && validation.values.poifilePath == '' &&
                                                                            (validation.touched.panfile && !$("#chkPAN").prop('checked')) ? (
                                                                            <FormFeedback type="invalid">{validation.errors.panfile}</FormFeedback>
                                                                        ) : null}
                                                                </Col>
                                                                <Col lg="4" style={{ marginTop: "35px", fontSize: "medium", fontWeight: "bold" }}>
                                                                    <a id="lnkPANDownload" href="" target="_blank" rel="noreferrer" style={{ visibility: "hidden" }}>
                                                                        <i className="bx bx-show" style={{ fontSize: "xx-large", marginTop: "-5px" }}></i>
                                                                    </a>
                                                                </Col>
                                                            </Row><br /><br />

                                                            <Row>
                                                                <h5 style={tabHeading}>POI(Proof of Identity) & POA(Proof of Address) Form</h5>
                                                            </Row>
                                                            <br></br>
                                                            <Row>
                                                                <Col lg="3">
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>Proof of Identity</label><span style={formMandatory}>*</span>
                                                                        <Input type="select"
                                                                            className="form-select"
                                                                            name="poi"
                                                                            id="ddlPOI"
                                                                            onChange={validation.handleChange}
                                                                            value={validation.values.poi || ""}
                                                                            invalid={
                                                                                validation.touched.poi && validation.errors.poi && rowsData.length == 0 ? true : false
                                                                            }
                                                                        >
                                                                            <option value="">Proof Of Identity</option>
                                                                            {
                                                                                poiData.map((value, key) => (
                                                                                    <option key={value.id} value={value.id}>
                                                                                        {value.poi}
                                                                                    </option>
                                                                                ))
                                                                            }
                                                                        </Input>
                                                                        {validation.touched.poi && validation.errors.poi && rowsData.length == 0 ? (
                                                                            <FormFeedback type="invalid">{validation.errors.poi}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="3">
                                                                    <FormGroup className="mb-3">
                                                                        <label>POI/POA</label><span style={formMandatory}>*</span>
                                                                        <Input type="select"
                                                                            className="form-select"
                                                                            name="poipoa"
                                                                            id="ddlPOIPOA"
                                                                            onChange={validation.handleChange}
                                                                            value={validation.values.poipoa || ""}
                                                                            invalid={
                                                                                validation.touched.poipoa && validation.errors.poipoa && rowsData.length == 0 ? true : false
                                                                            }
                                                                        >
                                                                            <option value="">Choose</option>
                                                                            <option value="1">POA</option>
                                                                            <option value="2">POI</option>
                                                                            <option value="3">POA & POI</option>
                                                                        </Input>
                                                                        {validation.touched.poipoa && validation.errors.poipoa && rowsData.length == 0 ? (
                                                                            <FormFeedback type="invalid">{validation.errors.poipoa}</FormFeedback>
                                                                        ) : null}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg="2">
                                                                    <FormGroup className="mb-3" style={{ marginTop: "25px" }}>
                                                                        <Button id="btnAdd" style={formButton} onClick={() => addPoiRows()}>
                                                                            Add
                                                                        </Button>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <Card>
                                                                        <CardBody>
                                                                            <div className="table-responsive">
                                                                                <Table className="align-middle mb-0" id="tbPOI">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th>POI</th>
                                                                                            <th>Enter Number</th>
                                                                                            <th>POI/POA</th>
                                                                                            <th>Expiry</th>
                                                                                            <th>Upload <small style={{ marginLeft: "3px", fontSize: '85%', fontWeight: '400' }}>(Kindly upload document in JPG,JPEG,PNG format only)</small></th>
                                                                                            <th>Delete</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <TableRows rowsData={rowsData}
                                                                                            deletePoiRows={deletePoiRows}
                                                                                            handleChange={handleChange} handleCheckChange={handleCheckChange} handleUploadChange={handleUploadChange}
                                                                                            errorMessage={ErrorMessage} 
                                                                                        />
                                                                                    </tbody>
                                                                                </Table>
                                                                            </div>
                                                                        </CardBody>
                                                                    </Card>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        <br></br>
                                                    </Form>
                                                    <Row>
                                                        <Col lg="8">
                                                        </Col>
                                                        <Col lg="4" style={{ textAlign: "right" }}>
                                                            <Button id="btnBack" style={{ marginLeft: "115px", backgroundColor: "rgb(154, 8, 79)", fontSize: "small", borderRadius: "0.5rem" }}
                                                                onClick={() => {
                                                                    history.push('/CreateNewAccount');
                                                                }} >
                                                                Back
                                                            </Button>

                                                            <Button id="firstN" style={formButtonFirstPage} type="submit" onClick={() => {
                                                                debugger;

                                                                let formData = {
                                                                    personalchoose: validation.values.personalchoose,
                                                                    firstname: validation.errors.firstname == undefined ? validation.values.firstname : "",
                                                                    // middlename: validation.errors.middlename == undefined ? validation.values.middlename : "",
                                                                    // lastname: validation.errors.lastname == undefined ? validation.values.lastname : "",
                                                                    phoneno: validation.values.phoneno,
                                                                    mobilenobelongsTo: validation.values.mobilenobelongsTo,
                                                                    gender: validation.values.gender,
                                                                    occupation: validation.values.occupation,
                                                                    dob: validation.values.dob,
                                                                    maritalstatus: validation.values.maritalstatus,
                                                                    nationality: validation.values.nationality,
                                                                    communicationaddress: validation.values.communicationaddress,
                                                                    communicationstate: validation.values.communicationstate,
                                                                    communicationcity: validation.errors.communicationcity == undefined ? validation.values.communicationcity : "",
                                                                    communicationpincode: validation.values.communicationpincode,
                                                                    permanentaddress: validation.values.permanentaddress,
                                                                    permanentstate: validation.values.permanentstate,
                                                                    permanentcity: validation.errors.permanentcity == undefined ? validation.values.permanentcity : "",
                                                                    permanentpincode: validation.values.permanentpincode,
                                                                    pan: validation.values.pan,
                                                                    panfile: validation.values.panfile,
                                                                    photofile: validation.values.photofile
                                                                }
                                                                if (userAccountType === 5) {
                                                                    delete formData.panfile;
                                                                    delete formData.photofile;
                                                                }

                                                                let isEmpty = CheckIsValid([formData])

                                                                if (!isEmpty)
                                                                    CreateAccount(activeTabVartical);
                                                            }} >
                                                                Save & Next
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </TabPane>

                                            <TabPane tabId={2}>
                                                <div>
                                                    <Form style={formBackground} className="needs-validation" onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation.handleSubmit();
                                                        return false;
                                                    }}>
                                                        <Row>
                                                            <h4 style={tabHeading}>Form no 60/61</h4>
                                                        </Row><br></br>
                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Transaction Particulars</label>
                                                                    <Input
                                                                        name="transactionparticulars"
                                                                        placeholder="Transaction Particulars"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txttransactionparticulars"
                                                                        maxLength="100"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.transactionparticulars || ""}
                                                                        invalid={
                                                                            validation.errors &&
                                                                                validation.errors.transactionparticulars &&
                                                                                (validation.touched &&
                                                                                    validation.touched.transactionparticulars) ? true : false
                                                                        }
                                                                        autocomplete="off"
                                                                    />
                                                                    {
                                                                        validation.errors &&
                                                                            validation.errors.transactionparticulars &&
                                                                            (validation.touched &&
                                                                                validation.touched.transactionparticulars) ? (
                                                                            <FormFeedback type="invalid">{validation.errors.transactionparticulars}</FormFeedback>
                                                                        ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Amount of Transactions</label>
                                                                    <Input
                                                                        name="transactionsamount"
                                                                        placeholder="Amount of Transactions"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txttransactionsamount"
                                                                        maxLength="15"
                                                                        onChange={e => { chkNumeric(e) }}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.transactionsamount || ""}
                                                                        invalid={
                                                                            validation.errors &&
                                                                                validation.errors.transactionsamount &&
                                                                                validation.errors.transactionsamount &&
                                                                                (validation.touched &&
                                                                                    validation.touched.transactionsamount) ? true : false
                                                                        }
                                                                        autocomplete="off"
                                                                    />
                                                                    {
                                                                        validation.errors &&
                                                                            validation.errors.transactionsamount &&
                                                                            (validation.touched &&
                                                                                validation.touched.transactionsamount) ? (
                                                                            <FormFeedback type="invalid">{validation.errors.transactionsamount}</FormFeedback>
                                                                        ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Details of income Tax ward/circle/range</label>
                                                                    <Input
                                                                        name="detailsofincometax"
                                                                        placeholder="Details Of Income Tax"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtdetailsofincometax"
                                                                        maxLength="50"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.detailsofincometax || ""}
                                                                        invalid={
                                                                            validation.errors &&
                                                                                validation.errors.detailsofincometax &&
                                                                                (validation.touched &&
                                                                                    validation.touched.detailsofincometax) ? true : false
                                                                        }
                                                                        autocomplete="off"
                                                                    />
                                                                    {
                                                                        validation.errors &&
                                                                            validation.errors.detailsofincometax &&
                                                                            (validation.touched &&
                                                                                validation.touched.detailsofincometax) ? (
                                                                            <FormFeedback type="invalid">{validation.errors.detailsofincometax}</FormFeedback>
                                                                        ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Reason for not having PAN</label>
                                                                    <Input
                                                                        name="reasonfornopan"
                                                                        placeholder="Reason For No PAN"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtreasonfornopan"
                                                                        maxLength="200"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.reasonfornopan || ""}
                                                                        invalid={
                                                                            validation.errors &&
                                                                                validation.errors.reasonfornopan &&
                                                                                (validation.touched &&
                                                                                    validation.touched.reasonfornopan) ? true : false
                                                                        }
                                                                        autocomplete="off"
                                                                    />
                                                                    {
                                                                        validation.errors &&
                                                                            validation.errors.reasonfornopan &&
                                                                            (validation.touched &&
                                                                                validation.touched.reasonfornopan) ? (
                                                                            <FormFeedback type="invalid">{validation.errors.reasonfornopan}</FormFeedback>
                                                                        ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <h4 style={label} className="font-size-14 mb-4">Are you assessed to tax?</h4>
                                                                    <Row>
                                                                        <Col md="2">
                                                                            <div className="form-check mb-3">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="exampleRadios"
                                                                                    id="rbaccessedtaxyes"
                                                                                    value="option1"
                                                                                    defaultChecked
                                                                                />
                                                                                <label style={label}
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios1"
                                                                                >
                                                                                    Yes
                                                                                </label>
                                                                            </div>
                                                                        </Col>
                                                                        <Col md="2">
                                                                            <div className="form-check">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="exampleRadios"
                                                                                    id="rbaccessedtaxno"
                                                                                    value="option2"
                                                                                />
                                                                                <label style={label}
                                                                                    className="form-check-label"
                                                                                    htmlFor="exampleRadios2"
                                                                                >
                                                                                    No
                                                                                </label>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row><br></br>
                                                        <Row>
                                                            <Col lg="8">
                                                            </Col>
                                                            <Col lg="4" style={{ textAlign: "right" }}>
                                                                <Button id="firstP" style={formButton} className={
                                                                    activeTabVartical === -1
                                                                        ? "previous disabled"
                                                                        : "previous"
                                                                } onClick={() => {
                                                                    toggleTabVertical(activeTabVartical - 1);
                                                                }} >
                                                                    Back
                                                                </Button>

                                                                <Button id="firstN" style={formButton} type="submit" onClick={() => {
                                                                    let isEmpty = CheckIsValid([{
                                                                        transactionparticulars: validation.values.transactionparticulars,
                                                                        transactionsamount: validation.values.transactionsamount,
                                                                        detailsofincometax: validation.values.detailsofincometax,
                                                                        reasonfornopan: validation.values.reasonfornopan,
                                                                    }])
                                                                    if (!isEmpty)
                                                                        CreateAccount(activeTabVartical);
                                                                }} >
                                                                    Save & Next
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </div>
                                            </TabPane>

                                            <TabPane tabId={3}>
                                                <div>
                                                    <Form style={formBackground} className="needs-validation" onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation.handleSubmit();
                                                        return false;
                                                    }}>
                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Expected origin of funds for credit.</label>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="fundsforcredit"
                                                                        id="ddlfundsforcredit"
                                                                    >
                                                                        <option value="">Funds for credit to Account</option>
                                                                        <option value="1">Local</option>
                                                                        <option value="2">Foreign Inward Remittances</option>
                                                                    </Input>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Expected Utilisation of funds by debit. </label>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="fundsbydebit"
                                                                        id="ddlfundsbydebit"
                                                                    >
                                                                        <option value="">Funds by debit to Account</option>
                                                                        <option value="0">Remittances aboard</option>
                                                                        <option value="1">Local</option>
                                                                    </Input>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Any accounts with other banks</label>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="otherbankaccounts"
                                                                        id="ddlotherbanksaccounts"
                                                                    >
                                                                        <option value="">Any Other Bank Accounts</option>
                                                                        {
                                                                            otherBankAccountsData.map((value, key) => (
                                                                                <option key={value.id} value={value.id}>
                                                                                    {value.otherBankAccount}
                                                                                </option>
                                                                            ))
                                                                        }
                                                                    </Input>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Monthly Income</label><span style={formMandatory}>*</span>
                                                                    <Input
                                                                        name="averageincome"
                                                                        placeholder="Rs.0000000"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtaverageincome"
                                                                        maxLength="15"
                                                                        onChange={(e) => {
                                                                            const { value } = e.target;
                                                                            chkNumeric(e)
                                                                            const data = getAnnualIncomeDetails(value);
                                                                            const { annualIncomeValue, annualTurnover } = data;
                                                                            validation.setFieldValue("annualincome", annualIncomeValue)
                                                                            validation.setFieldValue("annualactivity", annualTurnover)
                                                                        }}
                                                                        value={validation.values.averageincome || ""}
                                                                        autocomplete="off"
                                                                        invalid={
                                                                            validation.touched.averageincome && validation.errors.averageincome ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.averageincome && validation.errors.averageincome ? (
                                                                        <FormFeedback type="invalid">{validation.errors.averageincome}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Annual Income</label><span style={formMandatory}>*</span>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="annualincome"
                                                                        id="ddlannualincome"
                                                                        onChange={validation.handleChange}
                                                                        value={validation.values.annualincome || ""}
                                                                        invalid={
                                                                            validation.touched.annualincome && validation.errors.annualincome ? true : false
                                                                        }
                                                                    >
                                                                        {/* <option value="">Annual Income</option>
                                                                        <option value="1">Upto 100000</option>
                                                                        <option value="2">100001 to 500000</option>
                                                                        <option value="3">500001 to 1000000</option>
                                                                        <option value="4">1000001 to 2500000</option>
                                                                        <option value="5">Above 2500000</option> */}
                                                                        {configForAnnualIncome.map((data) => (
                                                                            <option value={data.value} key={data.value}>
                                                                                {data.label}
                                                                            </option>
                                                                        ))}
                                                                    </Input>
                                                                    {validation.touched.annualincome && validation.errors.annualincome ? (
                                                                        <FormFeedback type="invalid">{validation.errors.annualincome}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Annual activity/ A/c turnover</label><span style={formMandatory}>*</span>
                                                                    <Input
                                                                        name="annualactivity"
                                                                        placeholder="Rs.0000000"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtturnover"
                                                                        maxLength="15"
                                                                        onChange={e => { chkNumeric(e) }}
                                                                        value={validation.values.annualactivity || ""}
                                                                        autocomplete="off"
                                                                        invalid={
                                                                            validation.touched.annualactivity && validation.errors.annualactivity ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.annualactivity && validation.errors.annualactivity ? (
                                                                        <FormFeedback type="invalid">{validation.errors.annualactivity}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Education</label>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="education"
                                                                        id="ddleducation"
                                                                    >
                                                                        <option value="">Education</option>
                                                                        {
                                                                            educationData.map((value, key) => (
                                                                                <option key={value.id} value={value.id}>
                                                                                    {value.education}
                                                                                </option>
                                                                            ))
                                                                        }
                                                                    </Input>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Religion </label><span style={formMandatory}>*</span>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="religion"
                                                                        id="ddlreligion"
                                                                        value={validation.values.religion || ""}
                                                                        onChange={validation.handleChange}
                                                                        invalid={
                                                                            validation.touched.religion && validation.errors.religion ? true : false
                                                                        }
                                                                    >
                                                                        <option value="">Religion</option>
                                                                        <option value="Hindu">Hindu</option>
                                                                        <option value="Muslim">Muslim</option>
                                                                        <option value="Buddhist">Buddhist</option>
                                                                        <option value="Sikh">Sikh</option>
                                                                        <option value="Jain">Jain</option>
                                                                        <option value="Christian">Christian</option>
                                                                    </Input>
                                                                    {validation.touched.religion && validation.errors.religion ? (
                                                                        <FormFeedback type="invalid">{validation.errors.religion}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Caste</label><span style={formMandatory}>*</span>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="caste"
                                                                        id="caste"
                                                                        value={validation.values.caste || ""}
                                                                        onChange={validation.handleChange}
                                                                        invalid={
                                                                            validation.touched.caste && validation.errors.caste ? true : false
                                                                        }
                                                                    >
                                                                        <option value="">Caste</option>
                                                                        <option value={"Open Category"}>Open Category</option>
                                                                        <option value={"SC (Scheduled Castes)"}>SC (Scheduled Castes)</option>
                                                                        <option value={"ST (Scheduled Tribes)"}>ST (Scheduled Tribes)</option>
                                                                        <option value={"OBC"}>OBC</option>
                                                                    </Input>
                                                                    {validation.touched.caste && validation.errors.caste ? (
                                                                        <FormFeedback type="invalid">{validation.errors.caste}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Occupation Details</label><span style={formMandatory}>*</span>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="occupationdetails"
                                                                        id="ddloccupationdetails"
                                                                        value={validation.values.occupationdetails || ""}
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        invalid={
                                                                            validation.touched.occupationdetails && validation.errors.occupationdetails ? true : false
                                                                        }
                                                                    >
                                                                        <option value="">Occupation Details</option>
                                                                        {
                                                                            occupationData.map((value, key) => (
                                                                                <option key={value.id} value={value.id}>
                                                                                    {value.occupationName}
                                                                                </option>
                                                                            ))
                                                                        }
                                                                    </Input>
                                                                    {validation.touched.occupationdetails && validation.errors.occupationdetails ? (
                                                                        <FormFeedback type="invalid">{validation.errors.occupationdetails}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Professional Details</label>
                                                                    <Input
                                                                        name="lineofnusiness"
                                                                        placeholder="Professional Details"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtlineofnusiness"
                                                                        maxLength="100"
                                                                        autocomplete="off"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Name of the Employer/Firm/Institution</label><span style={formMandatory}>*</span>
                                                                    <Input
                                                                        name="businessname"
                                                                        placeholder="Name of the Employer/Firm/Institution"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtbusinessname"
                                                                        maxLength="100"
                                                                        autocomplete="off"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.businessname || ""}
                                                                        invalid={
                                                                            validation.touched.businessname && validation.errors.businessname ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.businessname && validation.errors.businessname ? (
                                                                        <FormFeedback type="invalid">{validation.errors.businessname}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Date of starting Business</label>
                                                                    <InputGroup>
                                                                        <Flatpickr
                                                                            className="form-control d-block flatpickr"
                                                                            placeholder="Date of starting Business"
                                                                            id="txtstartbusinessdate"
                                                                            options={{
                                                                                altInput: true,
                                                                                dateFormat: "d-M-Y",
                                                                                maxDate: "today",
                                                                                disableMobile: "true"
                                                                            }}
                                                                        />
                                                                    </InputGroup>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Office/ Business Address1</label>
                                                                    <Input
                                                                        name="bussinessaddress1"
                                                                        placeholder="Address1"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtbussinessaddress1"
                                                                        maxLength="300"
                                                                        autocomplete="off"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Office/ Business Address2</label>
                                                                    <Input
                                                                        name="bussinessaddress2"
                                                                        placeholder="Address2"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtbussinessaddress2"
                                                                        maxLength="300"
                                                                        autocomplete="off"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Office/ Business Address3</label>
                                                                    <Input
                                                                        name="bussinessaddress3"
                                                                        placeholder="Address3"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtbussinessaddress3"
                                                                        maxLength="300"
                                                                        autocomplete="off"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Office Contact</label>
                                                                    <Input
                                                                        name="officecontact"
                                                                        placeholder="Office Contact"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtofficecontact"
                                                                        maxLength="20"
                                                                        onChange={e => { chkNumeric(e) }}
                                                                        value={validation.values.officecontact || ""}
                                                                        autocomplete="off"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Mobile No.</label>
                                                                    {/* <span style={formMandatory}>*</span> */}
                                                                    <InputGroup>
                                                                        <div className="input-group-text">+91</div>
                                                                        <Input
                                                                            name="officemobileno"
                                                                            placeholder="Mobile No."
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtofficemobileno"
                                                                            maxLength="10"
                                                                            onChange={e => { chkNumeric(e) }}
                                                                            value={validation.values.officemobileno || ""}
                                                                            autocomplete="off"
                                                                            // invalid={
                                                                            //     validation.touched.officemobileno && validation.errors.officemobileno ? true : false
                                                                            // }
                                                                        />
                                                                    </InputGroup>
                                                                    {/* {validation.touched.officemobileno && validation.errors.officemobileno ? (
                                                                        <FormFeedback type="invalid">{validation.errors.officemobileno}</FormFeedback>
                                                                    ) : null} */}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Expected average balance </label><span style={formMandatory}>*</span>
                                                                    <Input
                                                                        name="expectedincome"
                                                                        placeholder="Rs.0000000"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtexpectedincome"
                                                                        maxLength="15"
                                                                        onChange={e => { chkNumeric(e) }}
                                                                        value={validation.values.expectedincome || ""}
                                                                        autocomplete="off"
                                                                        invalid={
                                                                            validation.touched.expectedincome && validation.errors.expectedincome ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.expectedincome && validation.errors.expectedincome ? (
                                                                        <FormFeedback type="invalid">{validation.errors.expectedincome}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Source of Income</label><span style={formMandatory}>*</span>
                                                                    <Input
                                                                        name="sourceofincome"
                                                                        placeholder="Source of Income"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtsourceofincome"
                                                                        autocomplete="off"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.sourceofincome || ""}
                                                                        invalid={
                                                                            validation.touched.sourceofincome && validation.errors.sourceofincome ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.sourceofincome && validation.errors.sourceofincome ? (
                                                                        <FormFeedback type="invalid">{validation.errors.sourceofincome}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Source of Wealth</label>
                                                                    <Input
                                                                        name="sourceofhealth"
                                                                        placeholder="Source of Wealth"
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="txtsourceofwealth"
                                                                        autocomplete="off"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Estimated Total value of Asset</label>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="estimatedvalue"
                                                                        id="ddlestimatedvalue"
                                                                    >
                                                                        <option value="">Estimated Total value of Asset</option>
                                                                        <option value="1">Upto 100000</option>
                                                                        <option value="2">100001 to 500000</option>
                                                                        <option value="3">500001 to 1000000</option>
                                                                        <option value="4">1000001 to 2500000</option>
                                                                        <option value="5">Above 2500000</option>
                                                                    </Input>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="4">
                                                                <FormGroup className="mb-3">
                                                                    <label style={label}>Reason to become Customer</label><span style={formMandatory}>*</span>
                                                                    <Input type="select"
                                                                        className="form-select"
                                                                        name="customerreasonid"
                                                                        id="ddlcustomerreasonid"
                                                                        onChange={validation.handleChange}
                                                                        value={validation.values.customerreasonid || ""}
                                                                        invalid={
                                                                            validation.touched.customerreasonid && validation.errors.customerreasonid ? true : false
                                                                        }
                                                                    >
                                                                        <option value="">Reason to become Customer</option>
                                                                        {
                                                                            reasonToBecomeCustomer.map((value, key) => (
                                                                                <option key={value.id} value={value.id}>
                                                                                    {value.reason}
                                                                                </option>
                                                                            ))
                                                                        }
                                                                    </Input>
                                                                    {validation.touched.customerreasonid && validation.errors.customerreasonid ? (
                                                                        <FormFeedback type="invalid">{validation.errors.customerreasonid}</FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="12">
                                                                <Row>
                                                                    <label style={label}>Assets Details </label>
                                                                </Row>
                                                                <Row>
                                                                    <Col lg="3">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkcommercialproperty"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                Commercial Property
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg="2">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkhouse"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                House
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg="2">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkplot"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                Plot
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg="2">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkothers"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                Others
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                </Row><br />

                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="6">
                                                                <Row>
                                                                    <FormGroup className="mb-3">
                                                                        <label style={label}>As per forign account tax compliance act (FATCA)</label>
                                                                    </FormGroup>
                                                                </Row>
                                                                <Row>
                                                                    <Col lg="6" style={{ marginTop: "-25px" }}>
                                                                        <FormGroup className="mb-3">
                                                                            <div className="mt-4">
                                                                                <Row>
                                                                                    <label>If you are tax residence of any country other than india</label>
                                                                                    <Col md="2">
                                                                                        <div className="form-check mb-3">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="radio"
                                                                                                name="taxresidence"
                                                                                                id="rbtaxresidenceyes"
                                                                                                value="option1"
                                                                                                // defaultChecked
                                                                                            />
                                                                                            <label style={label}
                                                                                                className="form-check-label"
                                                                                                htmlFor="exampleRadios1"
                                                                                            >
                                                                                                Yes
                                                                                            </label>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col md="2">
                                                                                        <div className="form-check">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="radio"
                                                                                                name="taxresidence"
                                                                                                id="rbtaxresidenceno"
                                                                                                value="option2"
                                                                                                defaultChecked
                                                                                                onChange={handleRadioButtonChange}
                                                                                            />
                                                                                            <label style={label}
                                                                                                className="form-check-label"
                                                                                                htmlFor="exampleRadios2"
                                                                                            >
                                                                                                No
                                                                                            </label>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                                <label
                                                                                    style={{visibility: resultOfFatca.taxNonIndia ? "visible" : "hidden", color: 'black'}}
                                                                                >
                                                                                    Note - Please fill FATCA Declaration form separately
                                                                                </label>
                                                                            </div>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col lg="6">
                                                                <Row><FormGroup className="mb-3">
                                                                    <label> </label></FormGroup>
                                                                </Row>
                                                                <Row>
                                                                    <Col lg="6" style={{ marginTop: "-25px" }}>
                                                                        <FormGroup className="mb-3">
                                                                            <div className="mt-4">
                                                                                <Row>
                                                                                    <label>If you are born in any country other than India</label>
                                                                                    <Col md="2">
                                                                                        <div className="form-check mb-3">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="radio"
                                                                                                name="born"
                                                                                                id="rbbornyes"
                                                                                                value="option1"
                                                                                                // defaultChecked
                                                                                            />
                                                                                            <label style={label}
                                                                                                className="form-check-label"
                                                                                                htmlFor="exampleRadios"
                                                                                            >
                                                                                                Yes
                                                                                            </label>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col md="2">
                                                                                        <div className="form-check">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="radio"
                                                                                                name="born"
                                                                                                id="rbbornno"
                                                                                                value="option2"
                                                                                                defaultChecked
                                                                                                onChange={handleRadioButtonChange}
                                                                                            />
                                                                                            <label style={label}
                                                                                                className="form-check-label"
                                                                                                htmlFor="exampleRadios2"
                                                                                            >
                                                                                                No
                                                                                            </label>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                                <label
                                                                                    style={{visibility: resultOfFatca.bornNonIndia ? "visible" : "hidden", color: 'black'}}
                                                                                >
                                                                                    Note - Please fill FATCA Declaration form separately
                                                                                </label>
                                                                            </div>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="6">
                                                                <Row>
                                                                    <Col lg="6">
                                                                        <Row>
                                                                            <Col lg="6">
                                                                                <label style={label}>Vehicle Type</label>
                                                                            </Col>
                                                                            <Col lg="6">
                                                                                <label style={label}>Year of Purchase</label>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col lg="6">

                                                                                <div className="form-check">
                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        id="chktwowheeler"
                                                                                    />
                                                                                    <label
                                                                                        className="form-check-label"
                                                                                        htmlFor="invalidCheck"
                                                                                    >
                                                                                        {" "}
                                                                                        Two Wheeler
                                                                                    </label>
                                                                                </div>
                                                                            </Col>
                                                                            <Col lg="4">
                                                                                <Row>
                                                                                    <FormGroup className="mb-3">
                                                                                        <Input
                                                                                            name="twowheeleryear"
                                                                                            placeholder="YYYY"
                                                                                            type="text"
                                                                                            className="form-control"
                                                                                            id="txttwowheeleryear"
                                                                                            maxLength="4"
                                                                                            onChange={e => { chkNumeric(e) }}
                                                                                            value={validation.values.twowheeleryear || ""}
                                                                                            autocomplete="off"
                                                                                        />
                                                                                    </FormGroup>
                                                                                </Row>

                                                                            </Col>

                                                                        </Row>
                                                                        <Row>
                                                                            <Col lg="6">
                                                                                <div className="form-check">
                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        id="chkcar"
                                                                                    />
                                                                                    <label
                                                                                        className="form-check-label"
                                                                                        htmlFor="invalidCheck"
                                                                                    >
                                                                                        {" "}
                                                                                        Car
                                                                                    </label>
                                                                                </div>
                                                                            </Col>
                                                                            <Col lg="4">
                                                                                <FormGroup className="mb-3">
                                                                                    <Input
                                                                                        name="caryear"
                                                                                        placeholder="YYYY"
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id="txtcaryear"
                                                                                        maxLength="4"
                                                                                        onChange={e => { chkNumeric(e) }}
                                                                                        value={validation.values.caryear || ""}
                                                                                        autocomplete="off"
                                                                                    />
                                                                                </FormGroup>
                                                                            </Col>

                                                                        </Row>
                                                                        <Row>
                                                                            <Col lg="6">
                                                                                <div className="form-check">
                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        id="chkother"
                                                                                    />
                                                                                    <label
                                                                                        className="form-check-label"
                                                                                        htmlFor="invalidCheck"
                                                                                    >
                                                                                        {" "}
                                                                                        Other
                                                                                    </label>
                                                                                </div>
                                                                            </Col>
                                                                            <Col lg="4">
                                                                                <FormGroup className="mb-3">
                                                                                    <Input
                                                                                        name="anyotheryear"
                                                                                        placeholder="YYYY"
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id="txtotheryear"
                                                                                        maxLength="4"
                                                                                        onChange={e => { chkNumeric(e) }}
                                                                                        value={validation.values.anyotheryear || ""}
                                                                                        autocomplete="off"
                                                                                    />
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </Row><br />
                                                                    </Col>
                                                                </Row>
                                                            </Col>


                                                            <Col lg="6">
                                                                <Row>
                                                                    <label style={label}>Whether you are interested in (Optional)</label>
                                                                </Row>
                                                                <Row>
                                                                    <Col lg="6">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkmutualfunds"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                Mutual Funds
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg="6">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkhealthinsurance"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                Health Insurance
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                </Row><br />

                                                                <Row>
                                                                    <Col lg="6">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkgeneralinsurance"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                General Insurance
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg="6">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkdemat"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                Demat
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                </Row><br />

                                                                <Row>
                                                                    <Col lg="6">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkpmsby"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                Pradhan Mantri Suraksha Bima Yojana (PMSBY)
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg="6">
                                                                        <div className="form-check">
                                                                            <Input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="chkpmjjby"
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor="invalidCheck"
                                                                            >
                                                                                {" "}
                                                                                Pradhan Mantri Jeevan Jyoti Bima Yojana (PMJJBY)
                                                                            </label>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="6">
                                                                <Row>
                                                                    <Col lg="3">
                                                                        <label style={label}>Vehicle maker</label>
                                                                    </Col>
                                                                    <Col lg="6">
                                                                        <Input
                                                                            name="carmaker"
                                                                            placeholder="Vehicle maker"
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="txtcarmaker"
                                                                            maxLength="50"
                                                                            autocomplete="off"
                                                                        />
                                                                    </Col>

                                                                </Row>
                                                            </Col>
                                                        </Row><br />

                                                        <Row>
                                                            <Col lg="8">
                                                            </Col>
                                                            <Col lg="4" style={{ textAlign: "right" }}>
                                                                <Button id="firstP" style={formButton} className={
                                                                    activeTabVartical === -1
                                                                        ? "previous disabled"
                                                                        : "previous"
                                                                } onClick={() => {
                                                                    if ($("#chkPAN").prop('checked') == true) {
                                                                        toggleTabVertical(activeTabVartical - 1)
                                                                    }
                                                                    else if ($("#chkPAN").prop('checked') == false) {
                                                                        toggleTabVertical(activeTabVartical - 2)
                                                                    }
                                                                }} >
                                                                    Back
                                                                </Button>

                                                                <Button id="firstN" style={formButton} type="submit" onClick={() => {
                                                                    debugger;

                                                                    let isEmpty = CheckIsValid([{
                                                                        annualactivity: validation.values.annualactivity,
                                                                        averageincome: validation.values.averageincome,
                                                                        expectedincome: validation.values.expectedincome,
                                                                        annualincome: validation.values.annualincome,
                                                                        // officemobileno: validation.values.officemobileno,
                                                                        customerreasonid: validation.values.customerreasonid,
                                                                        caste: validation.values.caste,
                                                                        religion: validation.values.religion,
                                                                        occupationdetails: validation.values.occupationdetails,
                                                                        businessname: validation.values.businessname,
                                                                        sourceofincome: validation.values.sourceofincome,
                                                                    }])

                                                                    if (!isEmpty)
                                                                        CreateAccount(activeTabVartical);
                                                                }} >
                                                                    Save & Next
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </div>
                                            </TabPane>

                                            <TabPane tabId={4}>
                                                <div>
                                                    <Form style={formBackground} className="needs-validation" onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation.handleSubmit();
                                                        return false;
                                                    }}>
                                                        <Row style={label}>
                                                            1. I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief and I
                                                                undertake to inform the Bank of any changes therein, immediately. In case any of the above information is found to
                                                                be false, untrue, misleading, or misrepresenting, I am aware that I may be held liable for it.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            2. I hereby confirm that my latest photograph has been affixed above and I have submitted a self-attested photocopy
                                                                KYC document in support of POI&amp; POA The information provided by me in this Form, is true, correct, and complete. I
                                                                also confirm that I am aware of the FATCA/ CRS Terms and Conditions and hereby accept the same.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            3. I certify that the Information provided by me in this Form, it&#39;s supporting Annexure as well as in the document any
                                                                evidence provided by me are, to the best of my knowledge and belief true, correct, and complete and that I have not
                                                                withheld any material information that may affect the assessment/categorization of the account as a Reportable
                                                                account or otherwise.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            4. I permit/authorize the Bank to collect, store, communicate and process information relating to the account and all
                                                                transaction therein, by the Bank and any of its affiliates wherever situated including sharing, transfer, and disclosure
                                                                between them and to the authorities in and/or outside India of any confidential information for compliance with any
                                                                law or regulation whether domestic or foreign at the time force.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            5. I also agree that my failure to disclose any material fact known to me, now or in future, may invalidate my
                                                                application,
                                                                Bank would be within its rights to put restrictions in the operations of my/our account or dose it or report to any
                                                                regulator and/or any authority designated by the Government of India (GOI)/RBI for the purpose or take any other
                                                                action as may be deemed appropriate by the Bank if the deficiency is not remedied by me within the stipulated
                                                                period.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            6. I hereby accept and acknowledge that the Bank shall have the right and authority to conduct investigations from the
                                                                available in public domain for confirming the information provided by me to the Bank.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            7. Any change in my KYC information and documents accordingly, viz, Name/Address/Communication Details/
                                                                constitution/ Occupation/ Business/ Income source/ Annual Income-Turnover Range/ Transaction range/ etc., the
                                                                same will be communicated to the Bank supporting with necessary documents, within 30 days from such change
                                                                came into existence.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            8. It shall be my responsibility to educate myself and to comply at all the times with relevant laws relating to reporting
                                                                under section 285BA of the Act read with the Rules there under.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            9. I also agree to finish such information and/or documents as the Bank may require from time to time on account of
                                                                any change in law either in India or abroad in this subject matter herein.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            10. I shall indemnify the Bank for any loss that may arise to the Bank on account of providing incorrect or incomplete information.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            11. The details provided by me in the form are as per the notified Rules 114G to 114H of the Income Tax Act, 1962.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            12. I hereby authorize Janata Sahakari Bank Ltd., Pune to share my information including KYC details with Central KYC Registry (CKYCR).
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            13. I give my explicit consent and authorized Janata Sahakari Bank Ltd. Pune, to download my KYC records from Central
                                                                KYC Records Registry (CKYCRR) for Updation and or verification purpose.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            14. Policy for Limiting Liability of Customers in unauthorized Electronic Banking transactions is available with the branch.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            15. I hereby authorize Janata Sahakari Bank Ltd., Pune to verify the documents provided by me (i. e. My document(s))
                                                                using any online or offline mode (for KYC/AML and other purpose).
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            16. I have read, understood, and hereby accept &amp; agree to all the Terms &amp; Conditions given for all the products &amp;
                                                                services that I have requested or provided to me.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            17. I have used my ATM Card regularly and hereby give my consent to Re-Carding the same after expiry of the card,
                                                                please renew my debit card &amp; debit the required charges to my account maintaining with you.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            18. I agree to abide to changes in any rules &amp; regulation in banking and accordingly give my
                                                                consent/undertaking/declaration concerned.
                                                        </Row><br></br>
                                                        <Row style={label}>
                                                            19. I hereby declare that I am the individual who is NOT or have NOT been entrusted domestically with prominent public
                                                                functions, for example, heads of state or of government, senior politicians, members of parliament, senior
                                                                government, judicial or military officials, senior executives of state-owned corporations, important political party
                                                                officials. Also, I have not any concern with any Politically Exposed Person/s.
                                                        </Row><br></br>
                                                        <Row>
                                                            <Col lg="8">
                                                                <Input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="chkTerms" />
                                                                <label style={label}><b> &nbsp;I agree to above terms and conditions. </b></label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg="8">
                                                            </Col>
                                                            <Col lg="4" style={{ textAlign: "right" }}>
                                                                <Button id="firstP" style={formButton} className={
                                                                    activeTabVartical === -1
                                                                        ? "previous disabled"
                                                                        : "previous"
                                                                } onClick={() => {
                                                                    toggleTabVertical(activeTabVartical - 1);
                                                                }} >
                                                                    Back
                                                                </Button>

                                                                <Button id="firstN" style={formButton}
                                                                    type="submit" onClick={() => {
                                                                        CreateAccount(activeTabVartical);
                                                                    }} >
                                                                    Save
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </div>
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                </div >
                            </CardBody >
                        </Card >

                    </Col >
                </Row >
            </Container >
        </React.Fragment >
    )
}

export default OtherHolder
